﻿/* Widget COD unificado: captura tracking + renderiza formulario configurable +
   dispara ViewContent/InitiateCheckout/Purchase con deduplicacion browser-CAPI.
   Reemplaza BACKEND_URL por la URL de tu app antes de subir como asset. */
(function () {
  // BACKEND_URL se puede: 1) reemplazar al subir el asset, 2) leer de window.COD_BACKEND (App Embed), 3) detectar automáticamente
  var BACKEND_URL = (typeof window !== 'undefined' && window.COD_BACKEND) || 'BACKEND_URL';
  var CFG_TTL = 60 * 1000; // 60s cache localStorage (matches server cache)

  // Ocultar el botón nativo del tema DE INMEDIATO (antes de cualquier fetch)
  // para evitar el "flash" de un botón y luego otro mientras carga la config.
  (function () {
    var s = document.createElement('style');
    s.id = 'cod-hide-native-early';
    s.textContent = [
      '.shopify-payment-button,[name="add"],.product-form__submit,',
      '.btn--add-to-cart,[data-shopify="payment-button"]{display:none!important}',
    ].join('');
    (document.head || document.documentElement).appendChild(s);
  })();

  // El merchant puede configurar un regex por campo (ej. celular peruano
  // "^9\d{8}$") desde el constructor de formulario -- antes se guardaba pero
  // nunca se aplicaba acá, igual que pasó una vez con "redirect_mode".
  function testRegex(pattern, val) {
    try { return new RegExp(pattern).test(val); } catch (e) { return true; }
  }

  // Borrador: ID único por carga de página (nuevo UUID cada vez que se carga el producto).
  // Así cada visita = nueva entrada. Si el cliente corrige datos o visita otro producto
  // también aparece como borrador independiente.
  var DRAFT_SESSION_KEY = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : (Date.now().toString(36) + Math.random().toString(36).slice(2));
  var draftSent = false;
  var draftTimer = null;

  // Enviar borrador al backend (debounced)
  function saveDraft(shop, fields, variantId) {
    if (draftTimer) clearTimeout(draftTimer);
    draftTimer = setTimeout(function () {
      var t = track();
      fetch(BACKEND_URL + '/api/public/draft?shop=' + encodeURIComponent(shop), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionKey: DRAFT_SESSION_KEY, action: 'update',
          variantId: variantId, fields: fields,
          // Datos del cliente
          phone:   fields.phone   || null,
          name:    fields.name    || null,
          city:    fields.city    || null,
          email:   fields.email   || null,
          address: fields.address || null,
          // URLs de recuperación
          full_url:     window.location.href,
          recovery_url: window.location.origin + window.location.pathname,
          // UTM completo
          utm_source:   t.utm_source,
          utm_medium:   t.utm_medium,
          utm_campaign: t.utm_campaign,
          utm_content:  t.utm_content,
          utm_term:     t.utm_term,
          utm_id:       t.utm_id,
          // Facebook
          fbp: t.fbp, fbc: t.fbc,
        }),
      }).catch(function (e) { console.error('COD borrador: no se pudo guardar —', e); });
    }, 1200);
  }

  // Marcar borrador como convertido cuando el pedido se envía con éxito
  function convertDraft(shop, orderId) {
    fetch(BACKEND_URL + '/api/public/draft?shop=' + encodeURIComponent(shop), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionKey: DRAFT_SESSION_KEY, action: 'convert', orderId: orderId }),
    }).catch(function () { /* no bloquear */ });
  }

  /* â”€â”€ Tracking helpers â”€â”€ */
  function getCookie(n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? m.pop() : ''; }
  function param(n) { return new URLSearchParams(location.search).get(n) || ''; }
  function save(k, v) { if (v) try { localStorage.setItem(k, v); } catch (e) { /* sin espacio en localStorage, ignorar */ } }
  function load(k) { return localStorage.getItem(k) || ''; }
  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8; return v.toString(16);
    });
  }

  // Persistir UTMs + ttclid en primer toque
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id'].forEach(function (u) { if (param(u)) save(u, param(u)); });
  if (param('ttclid')) save('ttclid', param('ttclid'));
  // Meta: si el visitante llega con fbclid (vino de un anuncio) pero el
  // pixel del navegador todavia no alcanzo a setear la cookie _fbc (carga
  // lenta, bloqueador, orden de scripts), construimos el valor manualmente
  // con el formato que exige Meta -- una sola vez por click real, nunca si
  // no hay fbclid. La cookie real del pixel (si existe) siempre tiene
  // prioridad sobre este respaldo -- ver track().
  var fbclidParam = param('fbclid');
  if (fbclidParam && !getCookie('_fbc') && !load('cod_fbc_fallback')) {
    save('cod_fbc_fallback', 'fb.1.' + Date.now() + '.' + fbclidParam);
  }

  function track() {
    return { fbp: getCookie('_fbp'), fbc: getCookie('_fbc') || load('cod_fbc_fallback') || '', ttclid: load('ttclid') || getCookie('ttclid'), ttp: getCookie('_ttp'), utm_source: load('utm_source'), utm_medium: load('utm_medium'), utm_campaign: load('utm_campaign'), utm_content: load('utm_content'), utm_term: load('utm_term'), utm_id: load('utm_id'), user_agent: navigator.userAgent };
  }

  function fireMeta(evName, evId, extra) { if (window.fbq) window.fbq('track', evName, extra || {}, { eventID: evId }); }
  function fireServer(shop, evName, evId, extra) {
    fetch(BACKEND_URL + '/api/public/track?shop=' + encodeURIComponent(shop), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ event: evName, event_id: evId, tracking: track() }, extra || {})),
    }).catch(function () { /* no bloquear si falla el tracking */ });
  }

  /* â”€â”€ Config cache â”€â”€ */
  function getConfig(shop) {
    var key = 'cod_cfg_' + shop;
    try {
      var c = JSON.parse(localStorage.getItem(key) || 'null');
      if (c && Date.now() - c.ts < CFG_TTL) return Promise.resolve(c.data);
    } catch (e) { /* cache corrupta */ }
    return fetch(BACKEND_URL + '/api/public/form-config?shop=' + encodeURIComponent(shop))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        try { localStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: data })); } catch (e) { /* sin espacio en localStorage, ignorar */ }
        return data;
      });
  }

  /* -- Ubigeo (Provincia/Distrito), dataset estatico del INEI: cache larga -- */
  var UBIGEO_TTL = 7 * 24 * 60 * 60 * 1000;
  var ubigeoPromise = null;
  function getUbigeo() {
    var key = 'cod_ubigeo_v1';
    try {
      var c = JSON.parse(localStorage.getItem(key) || 'null');
      if (c && Date.now() - c.ts < UBIGEO_TTL) return Promise.resolve(c.data);
    } catch (e) { /* cache corrupta */ }
    return fetch(BACKEND_URL + '/api/public/ubigeo')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        try { localStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: data })); } catch (e) { /* sin espacio en localStorage, ignorar */ }
        return data;
      })
      .catch(function () { return null; });
  }
  function ensureUbigeo() {
    if (!ubigeoPromise) ubigeoPromise = getUbigeo();
    return ubigeoPromise;
  }

  /* â”€â”€ DOM helpers â”€â”€ */
  function el(tag, styles, attrs) {
    var node = document.createElement(tag);
    if (styles) Object.assign(node.style, styles);
    for (var k in attrs || {}) {
      if (k === 'text') node.textContent = attrs[k];
      else if (k === 'html') node.innerHTML = attrs[k];
      else node.setAttribute(k, attrs[k]);
    }
    return node;
  }

  /* -- Autocomplete liviano: input de texto + lista filtrable, sin libs.
     Pensado para mobile: se escribe y se filtra en vivo, se toca un item
     de la lista para elegirlo. Solo se considera "elegido" un valor que
     esta en la lista de opciones (si el cliente escribe algo que no
     matchea nada, al salir del campo se limpia). */
  function buildAutocomplete(placeholder, borderColor, bgColor) {
    var box = document.createElement('div');
    box.style.cssText = 'position:relative;width:100%';

    var input = document.createElement('input');
    input.type = 'text';
    input.autocomplete = 'off';
    input.placeholder = placeholder;
    input.style.cssText = 'border-color:' + borderColor + ';background:' + bgColor;

    var list = document.createElement('div');
    list.style.cssText = 'position:absolute;left:0;right:0;top:100%;margin-top:4px;background:#fff;border:1px solid #d1d5db;border-radius:8px;max-height:190px;overflow-y:auto;z-index:60;display:none;box-shadow:0 6px 18px rgba(0,0,0,0.14)';

    box.appendChild(input);
    box.appendChild(list);

    var allOptions = [];
    var selected = '';
    var onSelectCb = null;

    function hideList() {
      list.style.display = 'none';
      if (input.value !== selected) input.value = selected;
    }

    // pointerdown/pointerup (mouse+touch+lápiz unificados) en vez de
    // mousedown+preventDefault: un swipe para hacer scroll y un tap para
    // seleccionar arrancan igual (los dos son un "down" sobre la opción) --
    // la única forma real de distinguirlos es comparar dónde bajó el dedo
    // contra dónde se levantó. Si se cancela el evento de entrada
    // (preventDefault en el "down") para evitar que el input pierda el
    // foco, el navegador nunca llega a reconocer el gesto como scroll y se
    // bloquea el swipe en toda la lista -- por eso acá NO se cancela nada
    // en el "down", solo se guarda la posición, y recién en el "up" se
    // decide: si el dedo se movió poco, fue un tap (seleccionar); si se
    // movió más que el umbral, fue scroll (no hacer nada, ya scrolleó solo).
    var supportsPointer = typeof window !== 'undefined' && !!window.PointerEvent;
    var tapDownEvent = supportsPointer ? 'pointerdown' : 'mousedown';
    var tapUpEvent   = supportsPointer ? 'pointerup'   : 'mouseup';
    var TAP_MOVE_THRESHOLD = 10; // px -- más que esto entre bajar y soltar = fue scroll, no tap

    function renderList(items) {
      list.innerHTML = '';
      if (!items.length) { list.style.display = 'none'; return; }
      items.slice(0, 60).forEach(function (opt) {
        var item = document.createElement('div');
        item.textContent = opt;
        item.style.cssText = 'padding:11px 12px;font-size:15px;cursor:pointer;border-bottom:1px solid #f3f4f6';
        var downX = 0, downY = 0, tracking = false;
        item.addEventListener(tapDownEvent, function (e) {
          downX = e.clientX; downY = e.clientY; tracking = true;
        });
        item.addEventListener(tapUpEvent, function (e) {
          if (!tracking) return;
          tracking = false;
          if (Math.abs(e.clientX - downX) > TAP_MOVE_THRESHOLD || Math.abs(e.clientY - downY) > TAP_MOVE_THRESHOLD) return;
          selected = opt;
          input.value = opt;
          hideList();
          if (onSelectCb) onSelectCb(opt);
        });
        // Si el navegador cancela el puntero (ej. porque decidió que es un
        // scroll y tomó el control), no llega el "up" -- limpiar el estado
        // igual para no arrastrar un "tracking" viejo al próximo toque.
        item.addEventListener(supportsPointer ? 'pointercancel' : 'mouseleave', function () { tracking = false; });
        list.appendChild(item);
      });
      list.style.display = 'block';
    }

    function filterAndShow() {
      var q = input.value.trim().toLowerCase();
      renderList(q ? allOptions.filter(function (o) { return o.toLowerCase().indexOf(q) >= 0; }) : allOptions);
    }

    input.addEventListener('input', function () { selected = ''; filterAndShow(); });
    input.addEventListener('focus', filterAndShow);
    // Red de seguridad si el campo pierde foco sin que el usuario haya
    // tocado nada (ej. tecla "listo" del teclado virtual) -- el cierre real
    // lo maneja el listener de click de más abajo, que no compite con nada.
    input.addEventListener('blur', function () { setTimeout(hideList, 300); });
    // Cierra al tocar/clickear afuera del cuadro -- funciona igual en mouse
    // y en touch, y no depende de ningún timing de foco.
    document.addEventListener('click', function (e) {
      if (!box.contains(e.target)) hideList();
    });

    return {
      el: box,
      input: input,
      setOptions: function (opts) { allOptions = opts || []; },
      getValue: function () { return selected; },
      setValue: function (v) { selected = allOptions.indexOf(v) >= 0 ? v : ''; input.value = selected; },
      onSelect: function (cb) { onSelectCb = cb; },
    };
  }

  /* -- Campo Ciudad: selector en cascada Provincia -> Distrito (INEI),
     apilado verticalmente (mas comodo en mobile que lado a lado) y con
     autocomplete en vez de <select> nativo (mas rapido para encontrar la
     ciudad en una lista de 194 provincias / ~1800 distritos). Devuelve un
     <div> que se comporta como un campo unico ante el resto del formulario:
     expone .value, .style.borderColor y .focus() -- el resto del codigo
     (validacion, borrador, submit) no necesita saber que son dos campos. */
  function buildCityField(ubigeo, borderColor, bgColor) {
    var wrap2 = document.createElement('div');
    wrap2.style.cssText = 'display:flex;flex-direction:column;gap:8px;width:100%';

    var provincias = Object.keys(ubigeo).sort(function (a, b) { return a.localeCompare(b, 'es'); });
    var limaIdx = provincias.indexOf('Lima');
    if (limaIdx > 0) { provincias.splice(limaIdx, 1); provincias.unshift('Lima'); }

    var provAuto = buildAutocomplete('Provincia...', borderColor, bgColor);
    var distAuto = buildAutocomplete('Distrito...', borderColor, bgColor);
    provAuto.setOptions(provincias);

    function loadDistritos(provName) { distAuto.setOptions(ubigeo[provName] || []); }

    provAuto.onSelect(function (p) {
      distAuto.setValue('');
      loadDistritos(p);
      distAuto.input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    distAuto.onSelect(function () {
      distAuto.input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (ubigeo['Lima']) provAuto.setValue('Lima');
    loadDistritos(provAuto.getValue());

    wrap2.appendChild(provAuto.el);
    wrap2.appendChild(distAuto.el);

    // Requiere provincia + distrito para considerarse completo (una sola
    // provincia sin distrito no basta para ubicar bien la entrega).
    Object.defineProperty(wrap2, 'value', {
      get: function () {
        var p = provAuto.getValue(), d = distAuto.getValue();
        return d ? (d + ', ' + p) : '';
      },
      set: function (v) {
        if (!v) return;
        var parts = String(v).split(',');
        var pName = parts.length > 1 ? parts[1].trim() : parts[0].trim();
        if (ubigeo[pName]) { provAuto.setValue(pName); loadDistritos(pName); }
        var dName = parts.length > 1 ? parts[0].trim() : '';
        if (dName && ubigeo[pName] && ubigeo[pName].indexOf(dName) >= 0) distAuto.setValue(dName);
      },
    });
    Object.defineProperty(wrap2, 'style', {
      get: function () {
        return {
          set borderColor(v) { provAuto.input.style.borderColor = v; distAuto.input.style.borderColor = v; },
          get borderColor() { return provAuto.input.style.borderColor; },
        };
      },
    });
    wrap2.focus = function () { provAuto.input.focus(); };
    return wrap2;
  }

  /* â”€â”€ Render form â”€â”€ */
  // Detecta el selector de "paquetes" (Compra 1/Compra 2/Compra 3) de la
  // app Vitals -- son radios name="quantity" con un <label data-price-cents>
  // asociado, y el precio de cada paquete YA viene con descuento especial
  // (no es precio unitario × cantidad, Vitals lo calcula aparte).
  function detectQuantityBreak() {
    var radios = document.querySelectorAll('input[type="radio"][name="quantity"]');
    for (var i = 0; i < radios.length; i++) {
      if (!radios[i].checked) continue;
      var label = radios[i].id ? document.querySelector('label[for="' + radios[i].id + '"]') : null;
      if (!label) label = radios[i].closest('label');
      if (!label || !label.hasAttribute('data-price-cents')) continue;
      var qty = parseInt(label.getAttribute('data-quantity'), 10) || parseInt(radios[i].value, 10) || 0;
      var cents = parseFloat(label.getAttribute('data-price-cents'));
      if (qty > 0 && cents >= 0) return { qty: qty, totalPrice: cents / 100 };
    }
    return null;
  }

  function buildForm(root, cfg, shop, variantId, initPrice, ubigeo, initialQty, qtyBreak) {
    initialQty = initialQty > 0 ? initialQty : 1;
    var r      = (cfg.border_radius || 8) + 'px';
    var pc     = cfg.primary_color || '#1a8917';
    var bg     = cfg.bg_color || '#ffffff';
    var tc     = cfg.text_color || '#000000';
    var bc     = cfg.border_color || '#d1d5db';
    // Color de borde específico de los campos (coincide con la vista previa
    // del constructor — vacío ahí cae al color primario, no al gris general).
    var fbc    = cfg.field_border_color || bc;
    var fBg    = cfg.field_bg_color || '#ffffff';
    var fIc    = cfg.field_icon_color || '#6b7280';
    var ts     = (cfg.text_size || 14) + 'px';
    var shadow = cfg.shadow ? '0 4px 16px rgba(0,0,0,0.12)' : 'none';

    var form = el('form', { background: bg, padding: '16px', borderRadius: '12px', boxShadow: shadow, fontSize: ts, color: tc });
    form.id = 'cod-form';
    form.style.setProperty('--cod-pc', pc);
    form.appendChild(el('input', null, { type: 'hidden', name: 'variant_id', value: variantId }));

    // Shipping rate seleccionada
    var selectedShipping = null;
    var basePrice = 0; // se actualizara cuando el cliente seleccione envio
    // Si vino de un paquete de Vitals, arrancar con el precio efectivo por
    // unidad que ese paquete implica (total del paquete / cantidad del
    // paquete) -- así toda la lógica de abajo (que ya sabe usar basePrice
    // en vez de initPrice cuando basePrice > 0) funciona sin duplicar nada.
    if (qtyBreak && qtyBreak.qty > 0) { basePrice = qtyBreak.totalPrice / qtyBreak.qty; }
    // Permite que openModal() actualice el precio efectivo si el cliente
    // cierra el modal, elige otro paquete, y lo vuelve a abrir.
    root.__codSetBasePrice = function (p) { basePrice = p; };
    var trust = cfg.trust || {};

    // â”€â”€ TRUST ELEMENTS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    // 3) Escasez â€” va primero (arriba del todo para generar urgencia)
    if (trust.stock_enabled) {
      var stockNum = trust.stock_mode === 'fixed'
        ? trust.stock_fixed
        : (function () {
            // Mismo nÃºmero durante la sesiÃ³n del cliente (consistencia)
            var key = 'cod_stock_' + shop;
            var cached = sessionStorage.getItem(key);
            if (cached) return Number(cached);
            var n = Math.floor(Math.random() * (trust.stock_max - trust.stock_min + 1)) + trust.stock_min;
            sessionStorage.setItem(key, String(n));
            return n;
          })();
      var stockText = (trust.stock_text || 'âš¡ Solo quedan {stock} unidades').replace('{stock}', stockNum);
      var stockBadge = el('div', {
        padding: '8px 14px', marginBottom: '10px', borderRadius: '8px',
        backgroundColor: '#fff7ed', border: '1px solid #fb923c',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', color: '#c2410c',
      });
      var stockDot = el('span', { width: '8px', height: '8px', backgroundColor: '#ef4444', borderRadius: '50%', display: 'inline-block', flexShrink: '0',
        animation: 'cod-pulse 1.5s infinite' });
      stockBadge.appendChild(stockDot);
      stockBadge.appendChild(document.createTextNode(stockText));
      form.insertBefore(stockBadge, form.firstChild);
    }

    // 2) Prueba social — diseño app profesional con animaciones reales
    if (trust.social_enabled) {
      var INTERVAL_MS = 6000;
      var CITIES_PE = ['Miraflores','San Isidro','Surco','La Molina','San Borja','Lince','Breña','Los Olivos','Callao','San Martín de Porres','Ate','Chorrillos','Villa El Salvador','Jesús María','Pueblo Libre','San Miguel','Magdalena','Arequipa','Trujillo','Chiclayo','Piura','Cusco','Ica','Huancayo','Tacna','Iquitos','Chimbote','Puno','Juliaca'];
      var NAMES_PE = ['María','Carlos','Ana','Luis','Rosa','Jorge','Carmen','Pedro','Sofía','Miguel','Valeria','Diego','Paola','Fernando'];
      var GRADIENTS = ['linear-gradient(135deg,#667eea,#764ba2)','linear-gradient(135deg,#f093fb,#f5576c)','linear-gradient(135deg,#4facfe,#00f2fe)','linear-gradient(135deg,#43e97b,#38f9d7)','linear-gradient(135deg,#fa709a,#fee140)','linear-gradient(135deg,#a18cd1,#fbc2eb)','linear-gradient(135deg,#fccb90,#d57eeb)'];
      var buyers4 = [];
      if (trust.recent_buyers && trust.recent_buyers.length > 0) {
        buyers4 = trust.recent_buyers.map(function (b, idx) { return { name: b.name, city: idx % 3 === 0 ? CITIES_PE[idx % CITIES_PE.length] : b.city, mins: b.mins_ago }; });
      }
      while (buyers4.length < 12) { var fi = buyers4.length; buyers4.push({ name: NAMES_PE[fi % NAMES_PE.length], city: CITIES_PE[fi % CITIES_PE.length], mins: (fi * 2) + 1 }); }
      var sCss = document.createElement('style');
      sCss.textContent = '@keyframes cod-slide-in{from{transform:translateX(14px);opacity:0}to{transform:translateX(0);opacity:1}}.cod-slide-in{animation:cod-slide-in 0.45s cubic-bezier(.22,1,.36,1) both}';
      document.head.appendChild(sCss);
      var socialCard = el('div', { marginBottom:'12px', borderRadius:'16px', overflow:'hidden', backgroundColor:'#fff', boxShadow:'0 4px 20px rgba(0,0,0,0.10),0 1px 4px rgba(0,0,0,0.05)' });
      var statsRow2 = el('div', { display:'flex', padding:'10px 4px 8px' });
      [{ icon:'✅', val:String(trust.social_count||0), sub:'compradores', bg:'#dcfce7' },{ icon:'🚚', val:'24 Hrs.', sub:'entrega', bg:'#dbeafe' },{ icon:'📞', val:'24/7', sub:'atención', bg:'#f3e8ff' }].forEach(function(s){
        var col2 = el('div',{flex:'1',display:'flex',flexDirection:'column',alignItems:'center',gap:'3px'});
        var ico2 = el('div',{width:'34px',height:'34px',borderRadius:'10px',backgroundColor:s.bg,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'16px',margin:'0 auto'});
        ico2.textContent = s.icon;
        var vl2 = document.createElement('span'); vl2.style.cssText='font-size:13px;font-weight:800;color:#111827;line-height:1;text-align:center'; vl2.textContent=s.val;
        var sb2 = document.createElement('span'); sb2.style.cssText='font-size:10px;color:#9ca3af;line-height:1;text-align:center'; sb2.textContent=s.sub;
        col2.appendChild(ico2); col2.appendChild(vl2); col2.appendChild(sb2); statsRow2.appendChild(col2);
      });
      socialCard.appendChild(statsRow2);
      socialCard.appendChild(el('div',{height:'1px',backgroundColor:'#f3f4f6',margin:'0 12px'}));
      var actWrap2 = el('div',{padding:'10px 12px'}); socialCard.appendChild(actWrap2);
      form.insertBefore(socialCard, form.firstChild);
      if (trust.social_popup) {
        var bIdx4 = 0;
        function renderBuyer4() {
          var b = buyers4[bIdx4 % buyers4.length]; bIdx4++;
          while (actWrap2.firstChild) actWrap2.removeChild(actWrap2.firstChild);
          var row4 = el('div',{display:'flex',alignItems:'center',gap:'10px'}); row4.className='cod-slide-in';
          var avWrap = el('div',{position:'relative',flexShrink:'0'});
          var av4 = el('div',{width:'36px',height:'36px',borderRadius:'50%',background:GRADIENTS[bIdx4%GRADIENTS.length],display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',fontWeight:'800',color:'#fff'});
          av4.textContent=(b.name||'C').charAt(0).toUpperCase();
          var badge4=el('div',{position:'absolute',bottom:'-1px',right:'-1px',width:'13px',height:'13px',borderRadius:'50%',backgroundColor:'#22c55e',border:'2px solid #fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'7px',color:'#fff',fontWeight:'900'}); badge4.textContent='✓';
          avWrap.appendChild(av4); avWrap.appendChild(badge4);
          var info4=el('div',{flex:'1',minWidth:'0'});
          var nm4=el('div',{fontSize:'13px',fontWeight:'700',color:'#111827',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}); nm4.textContent=b.name+' G.';
          var loc4=el('div',{fontSize:'10px',color:'#6b7280',marginTop:'1px'}); loc4.innerHTML='📍 '+b.city+' &nbsp;·&nbsp; hace '+b.mins+' min';
          info4.appendChild(nm4); info4.appendChild(loc4);
          var live4=el('div',{flexShrink:'0',display:'flex',alignItems:'center',gap:'3px',backgroundColor:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:'20px',padding:'2px 7px'});
          var ld4=el('span',{width:'5px',height:'5px',backgroundColor:'#22c55e',borderRadius:'50%',display:'inline-block'}); ld4.className='cod-pulse';
          var lt4=el('span',{fontSize:'9px',color:'#16a34a',fontWeight:'700',letterSpacing:'0.5px'}); lt4.textContent='EN VIVO';
          live4.appendChild(ld4); live4.appendChild(lt4);
          row4.appendChild(avWrap); row4.appendChild(info4); row4.appendChild(live4);
          actWrap2.appendChild(row4);
          // Progress bar
          var progWrap4=el('div',{height:'3px',backgroundColor:'#f3f4f6',borderRadius:'2px',overflow:'hidden',marginTop:'8px'});
          var pb4=el('div',{height:'100%',width:'0%',borderRadius:'2px',background:'linear-gradient(90deg,#667eea,#764ba2)',transition:'none'});
          progWrap4.appendChild(pb4); actWrap2.appendChild(progWrap4);
          setTimeout(function(){pb4.style.transition='width '+INTERVAL_MS+'ms linear';pb4.style.width='100%';},50);
        }
        renderBuyer4();
        setInterval(renderBuyer4, INTERVAL_MS);
      }
    }

    // Opciones de envío — cada tarifa es su propia tarjeta con borde (estilo
    // checkout nativo de Shopify), no una lista con divisores internos; la
    // seleccionada se resalta con el color primario, borde + fondo tenue.
    if (cfg.shipping && cfg.shipping.length > 0) {
      var shWrap = document.createElement('div');
      shWrap.style.cssText = 'margin-bottom:14px';
      var shTitle = document.createElement('p');
      shTitle.style.cssText = 'margin:0 0 8px;font-size:13px;font-weight:700;color:' + tc;
      shTitle.textContent = 'Opciones de envío';
      shWrap.appendChild(shTitle);

      var shList = document.createElement('div');
      shList.style.cssText = 'display:flex;flex-direction:column;gap:8px';
      shWrap.appendChild(shList);

      // Con 8 dígitos hex se agrega alfa sin pasar a rgba() — soportado en
      // todos los navegadores evergreen.
      var pcTint = /^#([0-9a-f]{6})$/i.test(pc) ? pc + '14' : 'rgba(0,0,0,0.04)';

      function paintShippingRow(rowEl, isSelected) {
        rowEl.style.borderColor = isSelected ? pc : bc;
        rowEl.style.background = isSelected ? pcTint : '#fff';
      }

      cfg.shipping.forEach(function (rate, i) {
        var row = document.createElement('label');
        row.style.cssText = 'display:flex;align-items:center;gap:12px;padding:13px 14px;cursor:pointer;' +
          'border:1.5px solid ' + bc + ';border-radius:' + r + ';transition:border-color .15s,background .15s';

        // Radio button — más grande que el default del navegador, para que
        // se vea igual de sólido que en un checkout nativo.
        var rb = document.createElement('input');
        rb.type = 'radio'; rb.name = 'cod_shipping';
        rb.value = JSON.stringify(rate);
        rb.style.cssText = 'width:19px;height:19px;flex-shrink:0;cursor:pointer;accent-color:' + pc + ';margin:0';
        if (i === 0) { rb.checked = true; selectedShipping = rate; paintShippingRow(row, true); }
        rb.addEventListener('change', (function(capturedRate, capturedRow) {
          return function () {
            selectedShipping = capturedRate;
            Array.prototype.forEach.call(shList.children, function (r2) { paintShippingRow(r2, r2 === capturedRow); });

            var shipCostNow = Number(capturedRate.price) || 0;
            // basePrice (no initPrice) porque puede venir ya ajustado por un
            // paquete de Vitals; y hay que multiplicar por la cantidad actual
            // -- antes este cálculo la ignoraba por completo, y si el
            // cliente cambiaba el envío después de subir la cantidad, el
            // total volvía a mostrar solo 1 unidad.
            var qtyNow = fields.quantity ? Math.max(1, parseInt(fields.quantity.value) || 1) : 1;
            var basePriceNow = basePrice > 0 ? basePrice : (parseFloat(initPrice) || 0);
            var newTotal = basePriceNow * qtyNow + shipCostNow;
            var cur = cfg.currency_symbol || 'S/.';

            // Actualizar cuadro resumen
            var shipEl = document.getElementById('cod-sum-ship');
            var totEl  = document.getElementById('cod-sum-total');
            if (shipEl) {
              shipEl.textContent = shipCostNow === 0 ? 'Gratis' : cur + ' ' + shipCostNow.toFixed(2);
              shipEl.style.color = shipCostNow === 0 ? '#16a34a' : '#111827';
            }
            if (totEl) {
              totEl.textContent = cur + ' ' + newTotal.toFixed(2);
              totEl.style.color = '#111827';
            }

            // Reusa updateBtnTotal (más abajo) en vez de reconstruir el texto
            // acá — esa otra copia no revisaba si button_text ya tiene el
            // placeholder {total}, y por eso quedaba duplicado ("... {total}
            // — S/. 69.80") cuando el merchant lo usa en su texto de botón.
            updateBtnTotal(newTotal);
          };
        })(rate, row));

        // Nombre + subtitulo
        var nameWrap = document.createElement('div');
        nameWrap.style.cssText = 'flex:1;min-width:0';
        var nameEl = document.createElement('span');
        nameEl.style.cssText = 'font-size:14px;font-weight:700;color:' + tc + ';display:block;line-height:1.3';
        nameEl.textContent = rate.emoji + ' ' + rate.name;
        nameWrap.appendChild(nameEl);
        // Subtitulo (campo dedicado, ej: "PAGO POR ADELANTADO DESDE")
        var subText = rate.subtitle || (rate.condition && rate.condition !== 'always' ? rate.condition : '');
        if (subText) {
          var subEl = document.createElement('span');
          subEl.style.cssText = 'font-size:11px;font-weight:600;color:#6b7280;display:block;margin-top:3px;letter-spacing:0.3px;text-transform:uppercase;line-height:1.4';
          subEl.textContent = subText;
          nameWrap.appendChild(subEl);
        }

        // Precio
        var priceEl = document.createElement('span');
        var isFree = !rate.price || rate.price === 0;
        priceEl.style.cssText = 'font-size:14px;font-weight:800;color:' + (isFree ? '#16a34a' : tc) + ';flex-shrink:0;white-space:nowrap';
        priceEl.textContent = isFree ? 'Gratis' : 'S/. ' + Number(rate.price).toFixed(2);

        row.appendChild(rb); row.appendChild(nameWrap); row.appendChild(priceEl);
        shList.appendChild(row);
      });
      form.appendChild(shWrap);
    }

    var fields = {};
    var helperEls = {};
    var helperDefaults = {};

    // CSS: label arriba, input abajo, todo pegado a la izquierda -- igual
    // que la vista previa del constructor de formulario. Antes era una
    // grilla de 2 columnas (label | input) que solo pasaba a apilado por
    // debajo de 440px; en la práctica el widget no siempre renderiza tan
    // angosto, y a un ancho intermedio el label quedaba arriba-izquierda
    // con el input empezando bien a la derecha, en vez de debajo y alineado.
    (function () {
      if (document.getElementById('cod-field-styles')) return;
      var s = document.createElement('style');
      s.id = 'cod-field-styles';
      s.textContent = [
        '.cod-fr{display:grid;grid-template-columns:1fr;align-items:center;gap:6px;margin-bottom:9px}',
        // white-space:normal (no nowrap) — etiquetas largas como "Correo
        // electrónico" o "Nombre completo" antes se salían de la columna y
        // se montaban sobre el input; ahora bajan a una 2da línea si hace falta.
        '.cod-fr .cod-lb{font-size:12px;font-weight:600;white-space:normal;text-align:left;padding-right:4px;line-height:1.3}',
        '.cod-fr .cod-lb em{color:#ef4444;font-style:normal;margin-left:2px}',
        '.cod-fr .cod-iw{position:relative}',
        // padding vertical más grande = mejor "área de toque" en mobile;
        // font-size 16px (no 13px) porque Safari/iOS hace zoom automático al
        // enfocar un input con letra más chica — ese zoom brusco es probable
        // que sea lo que se sentía como "hay que tocarlo varias veces".
        // text-align:left explícito -- sin esto, un contenedor padre (ej. el
        // modal) que centre texto se filtraba al placeholder/valor del
        // input y al texto de ayuda, viéndose distinto al de la vista previa
        // del constructor (que sí queda a la izquierda).
        '.cod-fr input,.cod-fr select,.cod-fr textarea{width:100%;padding:13px 10px 13px 34px;border:1px solid #d1d5db;border-radius:8px;font-size:16px;box-sizing:border-box;outline:none;font-family:inherit;background:#fff;color:#000;min-height:46px;text-align:left}',
        '.cod-fr input:focus,.cod-fr select:focus{border-color:var(--cod-pc,#1a8917);box-shadow:0 0 0 2px rgba(26,137,23,0.15)}',
        '.cod-fr .cod-ic{position:absolute;left:8px;top:50%;transform:translateY(-50%);font-size:14px;pointer-events:none}',
        '.cod-fr textarea{padding:9px 10px;min-height:68px;resize:vertical}',
        '.cod-fr-noicon input,.cod-fr-noicon select{padding-left:10px}',
        '.cod-fhelp{font-size:11px;color:#9ca3af;margin:1px 0 6px 0;text-align:left}',
      ].join('');
      document.head.appendChild(s);
    })();

    cfg.fields.forEach(function (f) {
      var fType = f.field_type || 'text';

      // Imagen
      if (fType === 'image' && f.placeholder) {
        var imgWrap = el('div', { marginBottom: '10px', textAlign: f.image_align || 'center' });
        var img = el('img', null, { src: f.placeholder });
        img.style.cssText = 'width:' + (f.image_size || 100) + '%;border-radius:6px;max-width:100%';
        imgWrap.appendChild(img);
        form.appendChild(imgWrap);
        return;
      }

      // Botones WhatsApp / enlace
      if (fType === 'whatsapp_btn' || fType === 'link_btn') {
        var xbtnColor = fType === 'whatsapp_btn' ? '#25d366' : '#6366f1';
        var xbtn = document.createElement('button');
        xbtn.type = 'button';
        xbtn.textContent = (fType === 'whatsapp_btn' ? '📱 ' : '🔗 ') + f.label;
        xbtn.style.cssText = 'width:100%;padding:10px;margin-bottom:10px;background:' + xbtnColor + ';color:#fff;border:none;border-radius:' + r + ';font-weight:700;font-size:13px;cursor:pointer';
        xbtn.onclick = function () {
          var url = fType === 'whatsapp_btn' ? 'https://wa.me/' + (f.placeholder||'').replace(/\D/g,'') : (f.placeholder || '#');
          window.open(url, '_blank');
        };
        form.appendChild(xbtn);
        return;
      }

      // Campo standard: layout 2 columnas (label izq, input der) estilo EasySell
      var wrap = document.createElement('div');
      wrap.className = 'cod-fr';

      // Label (columna izquierda)
      if (!f.hide_label) {
        var lblDiv = document.createElement('div');
        lblDiv.className = 'cod-lb';
        lblDiv.style.color = tc;
        lblDiv.textContent = f.label;
        if (f.required) {
          var ast = document.createElement('em');
          ast.textContent = '*';
          lblDiv.appendChild(ast);
        }
        wrap.appendChild(lblDiv);
      }

      // Input (columna derecha)
      var inpWrap = document.createElement('div');
      inpWrap.className = 'cod-iw';

      var inputEl;
      // El selector en cascada solo reemplaza el campo "city" por defecto
      // (texto libre) -- si el merchant ya lo personalizó como "select" con
      // su propia lista de ciudades (ej. para limitar zonas de entrega),
      // respetamos esa configuración y no la pisamos.
      if (f.key === 'city' && ubigeo && fType !== 'select') {
        // Sin icono superpuesto: son dos campos apilados (Provincia/Distrito)
        // y el icono de un solo input quedaría descentrado sobre los dos.
        wrap.classList.add('cod-fr-noicon');
        inputEl = buildCityField(ubigeo, fbc, fBg);
      } else if (fType === 'textarea') {
        inputEl = document.createElement('textarea');
        inputEl.placeholder = f.placeholder || f.label;
        inputEl.rows = 3;
        inputEl.style.cssText = 'border-color:' + fbc + ';background:' + fBg + ';color:' + tc;
      } else if (fType === 'select' && f.options) {
        inputEl = document.createElement('select');
        inputEl.style.cssText = 'border-color:' + fbc + ';background:' + fBg + ';color:' + tc;
        var defOpt = document.createElement('option'); defOpt.value = ''; defOpt.textContent = f.placeholder || 'Selecciona...'; inputEl.appendChild(defOpt);
        f.options.split('|').forEach(function (o) { var opt = document.createElement('option'); opt.value = o.trim(); opt.textContent = o.trim(); inputEl.appendChild(opt); });
      } else {
        var iconsMap = { phone: '📱', name: '👤', city: '📍', email: '✉️', address: '🏠' };
        var icon = (f.show_icon !== false && f.icon_emoji) ? f.icon_emoji : (iconsMap[f.key] || '');
        // Distintivo por campo para que el autofill del navegador no confunda
        // uno con otro (sin esto, algunos navegadores repiten el mismo valor
        // guardado en varios campos que no tienen "autocomplete" propio).
        var autoCompleteMap = { phone: 'tel', name: 'name', city: 'address-level2', email: 'email', address: 'street-address' };
        inputEl = document.createElement('input');
        inputEl.type = fType === 'number' ? 'number' : (fType === 'tel' ? 'tel' : (fType || 'text'));
        inputEl.name = f.key;
        inputEl.autocomplete = autoCompleteMap[f.key] || 'off';
        inputEl.placeholder = f.placeholder || f.label;
        inputEl.style.cssText = 'border-color:' + fbc + ';background:' + fBg + ';color:' + tc;
        if (f.key === 'quantity') { inputEl.value = String(initialQty); inputEl.min = '1'; }
        if (!icon) wrap.classList.add('cod-fr-noicon');
        // Tope real del navegador -- sin esto max_length quedaba guardado en
        // la config pero nunca se aplicaba, y el celular podia llevar
        // cualquier cantidad de digitos.
        if (f.max_length) inputEl.maxLength = f.max_length;

        if (fType === 'tel' && f.validate_phone !== false) {
          inputEl.addEventListener('input', function () {
            var val = inputEl.value;
            if (f.numeric_only) val = val.replace(/[^0-9]/g, '');
            if (f.strip_plus) val = val.replace(/^\+/, '');
            if (f.max_length) val = val.slice(0, f.max_length);
            inputEl.value = val;
          });
          // Feedback inmediato en cuanto el cliente termina de escribir (blur),
          // en vez de solo enterarse recién al enviar el formulario.
          if (f.regex_pattern) {
            inputEl.addEventListener('blur', function () {
              var val = inputEl.value.trim();
              var hlpEl = helperEls[f.key];
              if (!val || testRegex(f.regex_pattern, val)) return;
              inputEl.style.borderColor = '#ef4444';
              if (hlpEl) {
                hlpEl.textContent = f.error_message || 'Formato inválido.';
                hlpEl.style.color = '#ef4444';
                hlpEl.style.fontWeight = '700';
                hlpEl.style.display = 'block';
              }
            });
          }
        }

        if (icon) {
          var iconEl = document.createElement('span');
          iconEl.className = 'cod-ic';
          iconEl.style.color = fIc;
          iconEl.textContent = icon;
          inpWrap.appendChild(iconEl);
        }
      }

      if (f.required && inputEl.tagName !== 'SELECT') inputEl.required = true;
      inpWrap.appendChild(inputEl);
      wrap.appendChild(inpWrap);
      fields[f.key] = inputEl;
      form.appendChild(wrap);

      // Slot de ayuda/error SIEMPRE se crea (aunque no haya helper_text) para
      // que, si el campo falla la validación, el mensaje de error aparezca
      // pegado a ESE campo — no como un mensaje genérico al fondo del form.
      var hlp = document.createElement('p');
      hlp.className = 'cod-fhelp';
      hlp.textContent = f.helper_text || '';
      if (!f.helper_text) hlp.style.display = 'none';
      form.appendChild(hlp);
      helperEls[f.key] = hlp;
      helperDefaults[f.key] = f.helper_text || '';
    });

    // "Siguiente" del teclado (o Enter) pasa al próximo campo en vez de
    // intentar enviar el formulario a medio llenar.
    (function () {
      var order = cfg.fields.map(function (f) { return f.key; }).filter(function (k) { return fields[k]; });
      order.forEach(function (key, idx) {
        var el2 = fields[key];
        if (!el2 || el2.tagName === 'SELECT' || el2.tagName === 'TEXTAREA') return;
        var isLast = idx === order.length - 1;
        el2.setAttribute('enterkeyhint', isLast ? 'done' : 'next');
        el2.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          for (var j = idx + 1; j < order.length; j++) {
            if (fields[order[j]]) { fields[order[j]].focus(); return; }
          }
          el2.blur();
        });
      });
    })();

    // 1) WhatsApp preview â€” justo antes del botÃ³n
    if (trust.wa_enabled && trust.wa_text) {
      var waDiv = el('div', {
        padding: '10px 14px', marginTop: '10px', marginBottom: '4px',
        backgroundColor: trust.wa_bg_color || '#f0fdf4',
        border: '2px solid ' + (trust.wa_border_color || '#25d366'),
        borderRadius: '10px', display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '12px', color: '#166534',
      });
      var waIco = el('span', { fontSize: '22px', flexShrink: '0' }, { text: 'ðŸ“±' });
      var waTxt = el('span', { lineHeight: '1.5' }, { text: trust.wa_text });
      waDiv.appendChild(waIco); waDiv.appendChild(waTxt);
      form.appendChild(waDiv);
    }

    // BotÃ³n COD con {total} dinÃ¡mico
    var btnWrap = el('div', { display: 'flex', flexDirection: 'column', alignItems: 'center' });
    var codBtn  = el('button', { width: '100%', padding: '13px 0', marginTop: '6px', backgroundColor: pc, color: '#fff', fontWeight: '700', fontSize: (cfg.button_font_size || 16) + 'px', border: 'none', borderRadius: r, cursor: 'pointer', boxShadow: shadow, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }, { type: 'submit' });
    var codBtnText = el('span');
    codBtnText.id = 'cod-btn-main-text';
    var codBtnSub  = cfg.button_subtitle ? el('span', { fontSize: '11px', fontWeight: '400', opacity: '0.9' }, { text: cfg.button_subtitle }) : null;
    codBtn.appendChild(codBtnText);
    if (codBtnSub) codBtn.appendChild(codBtnSub);

    var currency = cfg.currency_symbol || 'S/.';
    function updateBtnTotal(total) {
      var icon = cfg.button_icon_emoji ? cfg.button_icon_emoji + ' ' : '';
      var txt = cfg.button_text || 'PAGO CONTRA ENTREGA';
      if (txt.indexOf('{total}') >= 0) {
        codBtnText.textContent = icon + txt.replace('{total}', currency + ' ' + total.toFixed(2));
      } else if (total > 0) {
        codBtnText.textContent = icon + txt + ' — ' + currency + ' ' + total.toFixed(2);
      } else {
        codBtnText.textContent = icon + txt;
      }
    }
    // Inicializar con precio + primera tarifa de envío seleccionada
    var initShipForBtn = (cfg.shipping && cfg.shipping.length > 0) ? (Number(cfg.shipping[0].price) || 0) : 0;
    updateBtnTotal((parseFloat(initPrice) || 0) * initialQty + initShipForBtn);

    var msg = el('p', { margin: '8px 0 0', fontSize: '13px', textAlign: 'center' });
    form.appendChild(codBtn);
    form.appendChild(msg);

    // BotÃ³n tarjeta
    if (cfg.card_enabled) {
      var cardBtn = el('button', { width: '100%', padding: '12px 0', marginTop: '8px', backgroundColor: cfg.card_color || '#141ac3', color: cfg.card_text_color || '#fff', fontWeight: '700', fontSize: '14px', border: 'none', borderRadius: r, cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }, { type: 'button' });
      var cBtnText = el('span', null, { text: cfg.card_text || 'Paga con tarjeta' });
      cardBtn.appendChild(cBtnText);
      if (cfg.card_subtitle) cardBtn.appendChild(el('span', { fontSize: '11px', fontWeight: '400', opacity: '0.9' }, { text: cfg.card_subtitle }));
      // Si no se configuró una URL fija, arma el checkout de Shopify
      // automáticamente para el producto/variante actual (no depende de
      // pegar un link a mano — cambia solo según el producto).
      cardBtn.onclick = function () {
        if (cfg.card_link) { window.location.href = cfg.card_link; return; }
        var qty = (fields.quantity && fields.quantity.value) ? Math.max(1, parseInt(fields.quantity.value) || 1) : 1;
        window.location.href = window.location.origin + '/cart/' + variantId + ':' + qty;
      };
      form.appendChild(cardBtn);
    }

    // 1-Tick Upsells
    var acceptedUpsells = [];
    if (cfg.upsells && cfg.upsells.length > 0) {
      cfg.upsells.forEach(function (u) {
        var borderCss = u.border_style !== 'none' && u.border_width > 0
          ? u.border_width + 'px ' + u.border_style + ' ' + u.border_color : 'none';
        var uWrap = el('div', { marginTop: '10px', backgroundColor: u.bg_color || '#f6fff4', border: borderCss, borderRadius: '10px', padding: '12px' });

        var uRow = el('div', { display: 'flex', gap: '10px', alignItems: 'flex-start' });
        var uCheck = document.createElement('input');
        uCheck.type = 'checkbox';
        uCheck.checked = Boolean(u.is_default_checked);
        uCheck.style.cssText = 'width:16px;height:16px;margin-top:3px;flex-shrink:0;cursor:pointer';
        uCheck.onchange = function () {
          if (uCheck.checked) { if (!acceptedUpsells.includes(u.linked_variant_id)) acceptedUpsells.push(u.linked_variant_id); }
          else { acceptedUpsells = acceptedUpsells.filter(function(v) { return v !== u.linked_variant_id; }); }
        };
        if (u.is_default_checked && u.linked_variant_id) acceptedUpsells.push(u.linked_variant_id);

        uRow.appendChild(uCheck);

        if (u.show_image && u.linked_image) {
          var uImg = el('img', { width: '64px', height: '64px', objectFit: 'cover', borderRadius: '8px', flexShrink: '0', border: '1px solid #e5e7eb' });
          uImg.setAttribute('src', u.linked_image);
          uImg.setAttribute('alt', u.linked_title || '');
          uRow.appendChild(uImg);
        }

        var uText = el('div', { flex: '1' });
        var offerText = (u.offer_text || '').replace('{{title}}', u.linked_title || '').replace('{{price}}', 'S/. ' + (u.offer_price || 0).toFixed(2));
        uText.appendChild(el('p', { margin: '0 0 3px', fontSize: '12px', fontWeight: '700', color: u.brand_color || '#1579ff', lineHeight: '1.4' }, { text: offerText }));
        // Precio con tachado (EasySell style)
        var priceRow = el('div', { display: 'flex', gap: '6px', alignItems: 'center' });
        if (u.compare_price && u.compare_price > u.offer_price) {
          priceRow.appendChild(el('span', { fontSize: '12px', color: '#9ca3af', textDecoration: 'line-through' }, { text: currency + ' ' + Number(u.compare_price).toFixed(2) }));
        }
        if (u.offer_price) {
          priceRow.appendChild(el('span', { fontSize: '14px', fontWeight: '800', color: '#16a34a' }, { text: currency + ' ' + Number(u.offer_price).toFixed(2) }));
        }
        uText.appendChild(priceRow);
        uRow.appendChild(uText);
        uWrap.appendChild(uRow);
        form.insertBefore(uWrap, codBtn);
      });
    }

    root.replaceChildren(form);

    // InitiateCheckout en primer focus
    var initFired = false;
    form.addEventListener('focusin', function () {
      if (initFired) return; initFired = true;
      var eid = uuid();
      fireMeta('InitiateCheckout', eid);
      fireServer(shop, 'InitiateCheckout', eid, {
        name:  fields.name  && fields.name.value,
        phone: fields.phone && fields.phone.value,
        email: fields.email && fields.email.value,
        city:  fields.city  && fields.city.value,
      });
    });

    // Actualizar total cuando cambia la cantidad
    if (fields.quantity) {
      fields.quantity.addEventListener('input', function () {
        var newQty = Math.max(1, parseInt(fields.quantity.value) || 1);
        fields.quantity.value = newQty;
        var price = basePrice > 0 ? basePrice : (parseFloat(initPrice) || 0);
        var ship  = selectedShipping ? (Number(selectedShipping.price) || 0) : 0;
        updateBtnTotal(price * newQty + ship);
        // Update summary subtotal
        var subEl = document.getElementById('cod-sum-subtotal');
        var totEl = document.getElementById('cod-sum-total');
        var cur   = cfg.currency_symbol || 'S/.';
        if (subEl) subEl.textContent = cur + ' ' + (price * newQty).toFixed(2);
        if (totEl) totEl.textContent  = cur + ' ' + (price * newQty + ship).toFixed(2);
        // Update qty badge in modal header
        var badge = document.querySelector('#cod-modal-drawer .qty-badge-modal');
        if (badge) badge.textContent = String(newQty);
      });
    }

    // Captura borrador en cada cambio de campo (para recuperar abandonos).
    // Antes esto era un solo listener de "change" en el <form>, esperando
    // que burbujeara desde cada input -- en vivo se vio que dejó de
    // dispararse (ningún borrador nuevo llegaba al backend) sin poder
    // reproducir la causa exacta. En vez de eso, ahora se engancha
    // directo a CADA campo con "input" (dispara en cada tecla, no solo al
    // perder el foco como "change") -- más agresivo, pero saveDraft ya
    // tiene su propio debounce de 1.2s así que no manda de más.
    function triggerSaveDraft() {
      var currentFields = {};
      for (var k in fields) { if (fields[k] && fields[k].value) currentFields[k] = fields[k].value; }
      saveDraft(shop, currentFields, variantId);
    }
    for (var fdKey in fields) {
      if (fields[fdKey]) fields[fdKey].addEventListener('input', triggerSaveDraft);
    }

    // Submit
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Front-end validation: check required fields before calling API.
      // El mensaje de error (personalizado por campo si el merchant lo
      // configuró, o uno genérico) aparece pegado al campo que falló, no
      // como un único mensaje al fondo del formulario.
      var hasError = false;
      var firstInvalid = null;
      cfg.fields.forEach(function(f) {
        if (!fields[f.key]) return;
        var val = (fields[f.key].value || '').trim();
        var hlpEl = helperEls[f.key];
        var lengthBad = val && ((f.min_length && val.length < f.min_length) || (f.max_length && val.length > f.max_length));
        var patternBad = val && !lengthBad && f.regex_pattern && !testRegex(f.regex_pattern, val);
        if (!f.required && !val) return; // vacio y opcional: nada que validar
        if (!val || lengthBad || patternBad) {
          fields[f.key].style.borderColor = '#ef4444';
          if (hlpEl) {
            hlpEl.textContent = f.error_message || (lengthBad
              ? ('Debe tener ' + (f.min_length === f.max_length ? f.min_length : (f.min_length || '') + '-' + (f.max_length || '')) + ' dígitos.')
              : patternBad ? 'Formato inválido.' : 'Este campo es obligatorio.');
            hlpEl.style.color = '#ef4444';
            hlpEl.style.fontWeight = '700';
            hlpEl.style.display = 'block';
          }
          if (!firstInvalid) firstInvalid = fields[f.key];
          hasError = true;
        } else {
          fields[f.key].style.borderColor = fbc;
          if (hlpEl) {
            hlpEl.textContent = helperDefaults[f.key];
            hlpEl.style.color = '#9ca3af';
            hlpEl.style.fontWeight = '400';
            hlpEl.style.display = helperDefaults[f.key] ? 'block' : 'none';
          }
        }
      });
      if (firstInvalid) firstInvalid.focus();
      if (hasError) {
        msg.style.color = '#ef4444';
        msg.textContent = 'Por favor completa todos los campos requeridos.';
        return;
      }

      codBtn.disabled = true;
      msg.style.color = '#6b7280';
      msg.textContent = 'Procesando tu pedido...';
      var shipCost = selectedShipping ? (Number(selectedShipping.price) || 0) : 0;
      var qty = Math.max(1, Number(fields.quantity ? fields.quantity.value : 1));

      var payload = {
        name:    (fields.name    ? fields.name.value    : '').trim(),
        phone:   (fields.phone   ? fields.phone.value   : '').trim(),
        email:   (fields.email   ? fields.email.value   : '').trim(),
        city:    (fields.city    ? fields.city.value    : '').trim(),
        address: (fields.address ? fields.address.value : '').trim(),
        items: [{ variant_id: Number(variantId), quantity: qty }],
        upsell_variant_ids: acceptedUpsells,
        shipping_cost: shipCost,
        shipping_name: selectedShipping ? selectedShipping.name : '',
        product_price: parseFloat(initPrice) || 0,
        tracking: track(),
      };
      var ctrl = new AbortController();
      var timer = setTimeout(function() { ctrl.abort(); }, 30000);
      fetch(BACKEND_URL + '/api/public/order?shop=' + encodeURIComponent(shop), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload), signal: ctrl.signal,
      })
        .then(function (r) { clearTimeout(timer); return r.json(); })
        .then(function (data) {
          if (data.ok) {
            convertDraft(shop, data.order_id);
            var mode = cfg.redirect_mode || 'custom_page';
            if (mode === 'none') {
              msg.style.color = '#16a34a';
              msg.textContent = '✅ ¡Gracias por tu pedido! Te contactaremos para coordinar la entrega.';
            } else {
              msg.style.color = '#16a34a';
              msg.textContent = '✅ Pedido recibido. Redirigiendo...';
              var dest = cfg.thank_you_url || '/';
              if (mode === 'shopify' && data.order_status_url) dest = data.order_status_url;
              else if (mode === 'whatsapp' && cfg.redirect_whatsapp) {
                dest = 'https://wa.me/' + cfg.redirect_whatsapp.replace(/\D/g, '') + '?text=' + encodeURIComponent('¡Hola! Acabo de realizar un pedido.');
              }
              setTimeout(function() {
                window.location.href = dest;
              }, 800);
            }
          } else {
            msg.style.color = '#ef4444';
            msg.textContent = data.detail || 'No se pudo procesar. Intenta de nuevo.';
            codBtn.disabled = false;
          }
        })
        .catch(function (err) {
          clearTimeout(timer);
          msg.style.color = '#ef4444';
          if (err && err.name === 'AbortError') {
            msg.textContent = '⚠️ Tiempo de espera agotado. Verifica tu conexión e intenta de nuevo.';
          } else {
            msg.textContent = '⚠️ Error de conexión. Verifica tu internet e intenta de nuevo.';
          }
          codBtn.disabled = false;
        });
    });

    // Actualizar total exacto desde Shopify variant price (via backend)
    fetch(BACKEND_URL + '/api/public/variant-price?shop=' + encodeURIComponent(shop) + '&variant=' + variantId)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.price) {
          basePrice = parseFloat(data.price);
          var currentQty = (fields.quantity && fields.quantity.value) ? Number(fields.quantity.value) : 1;
          var currentShip = selectedShipping ? (Number(selectedShipping.price) || 0) : 0;
          updateBtnTotal(basePrice * currentQty + currentShip);
          // Sync summary total too
          var totEl = document.getElementById('cod-sum-total');
          if (totEl) totEl.textContent = (cfg.currency_symbol || 'S/.') + ' ' + (basePrice * currentQty + currentShip).toFixed(2);
        }
      })
      .catch(function () { /* precio no disponible, se usa initPrice */ });
  }

  // CSS global para animaciones de trust elements
  (function () {
    var s = document.createElement('style');
    s.textContent = '@keyframes cod-pulse{0%,100%{opacity:1}50%{opacity:0.5}} .cod-pulse{animation:cod-pulse 1.5s infinite}';
    document.head.appendChild(s);
  })();

  // ── CSS global del widget ────────────────────────────────────────────────
  (function () {
    var s = document.createElement('style');
    s.id = 'cod-widget-styles';
    s.textContent = [
      // Forzar que TODO lo nuestro herede la tipografía real de la tienda
      // (inputs/botones/selects no heredan font-family por defecto del
      // navegador, así que sin esto se ven con la fuente del sistema en vez
      // de la del tema, ej. Roboto).
      '#cod-sticky-bar,#cod-sticky-bar *,#cod-modal-overlay,#cod-modal-overlay *{font-family:inherit}',
      // Sticky bar
      // Sin overflow:hidden — si el contador pasa a 2 líneas en pantallas
      // angostas, no queremos que se recorte (no hay bordes redondeados acá
      // que justifiquen el overflow:hidden).
      '#cod-sticky-bar{position:fixed;bottom:0;left:0;right:0;z-index:9998;background:#fff;box-shadow:0 -4px 24px rgba(0,0,0,0.14);display:flex;flex-direction:column;font-family:inherit}',
      '#cod-sticky-bar .cod-sb-row{display:flex;align-items:center;gap:10px;padding:10px 16px 12px}',
      // En escritorio/tablet (viewport ancho) evitar que el botón se estire de punta a punta
      '@media(min-width:768px){#cod-sticky-bar .cod-sb-row{max-width:600px;margin:0 auto;width:100%;box-sizing:border-box}}',
      '@supports(padding-bottom:env(safe-area-inset-bottom)){#cod-sticky-bar .cod-sb-row{padding-bottom:calc(12px + env(safe-area-inset-bottom))}}',
      '#cod-urgency-bar{background:#ffe500;padding:8px 16px;text-align:center;font-size:13px;font-weight:800;color:#111827;letter-spacing:0.3px;line-height:1.35;white-space:normal;word-break:break-word}',
      '@media(max-width:360px){#cod-urgency-bar{font-size:11px;padding:7px 10px}}',
      '#cod-sticky-bar button:active{opacity:0.85}',
      // Modal overlay — SIEMPRE una tarjeta flotando centrada con el fondo
      // oscuro visible alrededor (igual en mobile y desktop, como en la
      // vista previa del constructor) — ya no es una hoja pegada de punta
      // a punta abajo de la pantalla.
      '#cod-modal-overlay{position:fixed;inset:0;z-index:9999;background:rgba(17,24,39,0.55);display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;opacity:0;pointer-events:none;transition:opacity 0.22s ease}',
      '#cod-modal-overlay.cod-open{opacity:1;pointer-events:auto}',
      '#cod-modal-drawer{background:#fff;width:100%;max-width:480px;max-height:88vh;border-radius:20px;overflow-y:auto;padding:0;transform:scale(0.96);opacity:0;transition:transform 0.28s cubic-bezier(.22,1,.36,1),opacity 0.22s ease;box-shadow:0 24px 64px rgba(0,0,0,0.32)}',
      '#cod-modal-overlay.cod-open #cod-modal-drawer{transform:scale(1);opacity:1}',
      '.cod-handle{display:none}',
      // Scroll padding para el sticky bar
      'body.cod-sticky-active{padding-bottom:80px}',
      // Ocultar botones nativos de Shopify
      '.cod-hide-native .product-form__buttons,[data-cod-hide]{display:none!important}',
      // Animaciones
      '@keyframes cod-fade-in{from{opacity:0}to{opacity:1}}',
      // Pulso sutil en el botón principal, para llamar la atención (propio,
      // no copiado de ninguna otra app)
      '@keyframes cod-btn-pulse{0%,100%{box-shadow:0 4px 14px rgba(0,0,0,0.18)}50%{box-shadow:0 4px 14px rgba(0,0,0,0.18),0 0 0 6px rgba(255,255,255,0.25)}}',
      '.cod-btn-pulse{animation:cod-btn-pulse 1.8s ease-in-out infinite}',
    ].join('');
    document.head.appendChild(s);
  })();

  // Auto-deteccion: funciona con snippet (cod-form.liquid) Y con ScriptTag automatico
  document.addEventListener('DOMContentLoaded', function () {
    // Widget de carrito: corre en CUALQUIER página (el carrito no es propio
    // de una sola página, a diferencia del formulario de producto de abajo,
    // que sí necesita estar en una página de producto para saber qué
    // vender). Por eso va acá, antes del resto, y no depende de isProduct.
    var cartShop = (window.COD_SHOP) || (window.Shopify && window.Shopify.shop) || '';
    if (cartShop) runCartWidget(cartShop);

    var shop, variantId, productTitle, productPrice, productImage;

    // Modo A: variables Liquid inyectadas por theme.liquid (más confiable)
    if (window.COD_IS_PRODUCT && window.COD_SHOP) {
      shop         = window.COD_SHOP || '';
      variantId    = String(window.COD_VARIANT || '');
      productTitle = window.COD_TITLE || '';
      productPrice = String(window.COD_PRICE || '');
      productImage = window.COD_IMAGE || '';
    }
    // Modo B: snippet cod-form.liquid con data-attributes
    else {
      var rootEl = document.getElementById('cod-form-root');
      if (rootEl && rootEl.getAttribute('data-shop')) {
        shop         = rootEl.getAttribute('data-shop') || '';
        variantId    = rootEl.getAttribute('data-variant-id') || '';
        productTitle = rootEl.getAttribute('data-product-title') || '';
        productPrice = rootEl.getAttribute('data-product-price') || '';
        productImage = rootEl.getAttribute('data-product-image') || '';
      }
      // Modo C: ScriptTag puro — detección automática desde globals y DOM
      else {
        var isProduct = (
          (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.pageType === 'product') ||
          (window.location.pathname.indexOf('/products/') !== -1 && window.location.pathname.indexOf('/collections/') === -1)
        );
        if (!isProduct) return;

        shop = (window.Shopify && window.Shopify.shop) || '';
        if (!shop) return;

        // Variant ID — buscar en múltiples selectores
        var idSelectors = ['form[action*="/cart/add"] [name="id"]', '.product-form [name="id"]', '[name="id"]', '[data-variant-id]'];
        for (var si = 0; si < idSelectors.length; si++) {
          var el = document.querySelector(idSelectors[si]);
          if (el) { variantId = el.value || el.getAttribute('data-variant-id') || ''; break; }
        }

        productTitle = ''; productPrice = ''; productImage = '';
        try {
          if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
            var prd = window.ShopifyAnalytics.meta.product;
            productTitle = prd.title || '';
            if (prd.price) productPrice = (Number(prd.price) / 100).toFixed(2);
          }
        } catch(ex) { /* */ }
        if (!productTitle) productTitle = document.title.split(' – ')[0].split(' | ')[0].trim();

        var imgSelectors = ['.product__media img', '.product-featured-img', '.product-single__photo img', '[data-product-featured-image]', '.ProductItem__Image'];
        for (var ii = 0; ii < imgSelectors.length; ii++) {
          var imgEl = document.querySelector(imgSelectors[ii]);
          if (imgEl) { productImage = imgEl.src || ''; break; }
        }

        // Si todavía no hay variant, esperar a que el theme los hidrate
        if (!variantId) {
          setTimeout(function() {
            for (var si2 = 0; si2 < idSelectors.length; si2++) {
              var el2 = document.querySelector(idSelectors[si2]);
              if (el2 && el2.value) { variantId = el2.value; runCOD(shop, variantId, productTitle, productPrice, productImage); break; }
            }
          }, 1000);
          return;
        }
      }
    }

    if (!shop || !variantId) return;
    runCOD(shop, variantId, productTitle, productPrice, productImage);
  });

  function runCOD(shop, variantId, productTitle, productPrice, productImage) {
    // Usar los parámetros recibidos (NO re-leer del DOM)
    if (!shop || !variantId) return;

    // Precargar el dataset de ubigeo en paralelo -- para cuando el cliente
    // abra el drawer (form lazy) ya suele estar listo, sin esperar el fetch.
    ensureUbigeo();

    // ViewContent al cargar
    var viewId = uuid();
    fireMeta('ViewContent', viewId, { content_ids: [variantId], content_type: 'product' });
    fireServer(shop, 'ViewContent', viewId, {});

    // ── Cargar configuración ──────────────────────────────────────────────
    getConfig(shop).then(function (cfg) {
      // Apagador real: si el merchant desactivó el formulario, no renderizar
      // nada y devolver el botón nativo que se ocultó de entrada — el widget
      // queda completamente inerte, sin dejar ningún resto activo en la tienda.
      if (cfg.form_enabled === false) {
        var earlyHideStyle = document.getElementById('cod-hide-native-early');
        if (earlyHideStyle) earlyHideStyle.remove();
        return;
      }
      // Colocación = "Solo página del carrito": en la página de producto no
      // se muestra nada propio (ni botón inline ni barra sticky), y el botón
      // nativo "Agregar al carrito" del tema queda tal cual -- por eso se
      // saca el estilo que lo escondía apenas cargó la página.
      if (cfg.placement === 'cart_page') {
        var earlyHideStyle2 = document.getElementById('cod-hide-native-early');
        if (earlyHideStyle2) earlyHideStyle2.remove();
        return;
      }
      var pc      = cfg.primary_color || '#1a8917';
      var btnTxt  = (cfg.button_text || 'PAGO CONTRA ENTREGA').replace(/{total}/g, '');
      var btnSub  = cfg.button_subtitle || 'Entrega en 24 Hrs';
      var r       = (cfg.border_radius || 8) + 'px';

      // ── STICKY BAR estilo EasySell: qty stepper + botón ────────────────
      // El elemento se arma siempre (otras partes del código leen qtyVal/
      // qtyDisplay/stickyBtn) pero si el merchant la ocultó desde
      // Configuración > Visibilidad, nunca se agrega al body ni se revela
      // -- ver más abajo, donde se decide si se inserta.
      if (!cfg.hide_sticky_bar) document.body.classList.add('cod-sticky-active');

      var stickyBar = document.createElement('div');
      stickyBar.id = 'cod-sticky-bar';
      stickyBar.style.display = 'none'; // IntersectionObserver lo revela

      // Qty stepper (izquierda)
      var qtyVal = 1;
      var qtyWrap = document.createElement('div');
      qtyWrap.style.cssText = 'display:flex;align-items:stretch;border:2px solid #e5e7eb;border-radius:' + r + ';overflow:hidden;flex-shrink:0;height:52px';

      function makeQtyBtn(lbl) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = lbl;
        b.style.cssText = 'width:44px;border:none;background:#f9fafb;font-size:20px;cursor:pointer;color:#374151;font-family:inherit;line-height:1';
        b.onmouseenter = function(){ b.style.background='#f3f4f6'; };
        b.onmouseleave = function(){ b.style.background='#f9fafb'; };
        return b;
      }
      var qtyMinus = makeQtyBtn('\u2212'); // minus sign
      var qtyDisplay = document.createElement('span');
      qtyDisplay.style.cssText = 'min-width:44px;display:flex;align-items:center;justify-content:center;font-size:16px;font-weight:700;color:#111827;border-left:2px solid #e5e7eb;border-right:2px solid #e5e7eb;font-family:inherit';
      qtyDisplay.textContent = '1';
      var qtyPlus = makeQtyBtn('+');

      qtyMinus.onclick = function () { if (qtyVal > 1) { qtyVal--; qtyDisplay.textContent = qtyVal; } };
      qtyPlus.onclick  = function () { qtyVal++; qtyDisplay.textContent = qtyVal; };

      qtyWrap.appendChild(qtyMinus);
      qtyWrap.appendChild(qtyDisplay);
      qtyWrap.appendChild(qtyPlus);

      // Botón COD (derecha, tamaño EasySell)
      var stickyBtn = document.createElement('button');
      stickyBtn.type = 'button';
      stickyBtn.className = 'cod-btn-pulse';
      stickyBtn.style.cssText = 'flex:1;background:' + pc + ';color:#fff;border:none;border-radius:' + r + ';padding:0 20px;font-weight:700;font-size:16px;cursor:pointer;font-family:inherit;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;height:52px;box-shadow:0 4px 14px rgba(0,0,0,0.18);transition:filter 0.15s';
      stickyBtn.onmouseenter = function(){ stickyBtn.style.filter='brightness(1.08)'; };
      stickyBtn.onmouseleave = function(){ stickyBtn.style.filter='none'; };
      var btnMain = document.createElement('span');
      btnMain.textContent = btnTxt.trim();
      stickyBtn.appendChild(btnMain);
      if (btnSub) {
        var btnSubEl = document.createElement('span');
        btnSubEl.style.cssText = 'font-size:11px;font-weight:400;opacity:0.9';
        btnSubEl.textContent = btnSub;
        stickyBtn.appendChild(btnSubEl);
      }

      // Countdown urgency banner (above the button row)
      var trust = cfg.trust || {};
      var cdEnabled = trust.countdown_enabled === true; // default OFF — must be explicitly enabled
      var cdMinutes = parseInt(trust.countdown_minutes) || 30;
      var cdText = trust.countdown_text || '\u00a1DATE PRISA! LA OFERTA TERMINA EN {timer}';
      var urgencyBar = document.createElement('div');
      urgencyBar.id = 'cod-urgency-bar';
      if (cdEnabled) {
        // sessionStorage para que el timer persista durante la visita
        var CD_KEY = 'cod_cd_' + shop;
        var remaining = parseInt(sessionStorage.getItem(CD_KEY)) || (cdMinutes * 60);
        function fmtTime(s) { var m = Math.floor(s/60); var sec = s%60; return (m<10?'0':'')+m+':'+(sec<10?'0':'')+sec; }
        urgencyBar.textContent = cdText.replace('{timer}', fmtTime(remaining));
        var cdInterval = setInterval(function() {
          remaining = Math.max(0, remaining - 1);
          try { sessionStorage.setItem(CD_KEY, remaining); } catch(e){}
          urgencyBar.textContent = cdText.replace('{timer}', fmtTime(remaining));
          if (remaining <= 0) { clearInterval(cdInterval); urgencyBar.style.display = 'none'; }
        }, 1000);
        stickyBar.appendChild(urgencyBar);
      }

      // Inner row: qty stepper + COD button
      var btnRow = document.createElement('div');
      btnRow.className = 'cod-sb-row';
      btnRow.appendChild(qtyWrap);
      btnRow.appendChild(stickyBtn);
      stickyBar.appendChild(btnRow);
      if (!cfg.hide_sticky_bar) document.body.appendChild(stickyBar);


      // ── MODAL DRAWER ──────────────────────────────────────────────────
      var overlay = document.createElement('div');
      overlay.id = 'cod-modal-overlay';

      var drawer = document.createElement('div');
      drawer.id = 'cod-modal-drawer';

      // Drag handle
      var handle = document.createElement('div');
      handle.className = 'cod-handle';
      drawer.appendChild(handle);

      // Header del modal
      var modalHeader = document.createElement('div');
      // ── Header sticky del modal ──
      modalHeader.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:12px 16px;position:sticky;top:0;background:#fff;z-index:2;border-bottom:1px solid #e5e7eb';
      var modalTitle = document.createElement('div');
      modalTitle.style.cssText = 'font-size:15px;font-weight:700;color:#111827;font-family:inherit';
      modalTitle.textContent = 'Favor ingresar tus datos para realizar el pedido';
      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', 'Cerrar');
      closeBtn.style.cssText = 'border:none;background:#f3f4f6;width:32px;height:32px;min-width:32px;border-radius:50%;font-size:20px;cursor:pointer;color:#374151;line-height:1;padding:0;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-family:inherit';
      closeBtn.innerHTML = '&times;';
      modalHeader.appendChild(modalTitle); modalHeader.appendChild(closeBtn);
      drawer.appendChild(modalHeader);

      // ── Resumen del producto ──
      var productSummary = document.createElement('div');
      productSummary.style.cssText = 'padding:12px 16px;border-bottom:1px solid #f3f4f6';

      // Fila producto
      if (productTitle || productImage) {
        var prodRow = document.createElement('div');
        prodRow.style.cssText = 'display:flex;align-items:center;gap:10px;margin-bottom:12px';
        if (productImage) {
          var thumbWrap = document.createElement('div');
          thumbWrap.style.cssText = 'position:relative;flex-shrink:0';
          var thumb = document.createElement('img');
          thumb.src = productImage;
          thumb.style.cssText = 'width:80px;height:80px;object-fit:cover;border-radius:10px;border:1px solid #e5e7eb';
          var qtyBadge = document.createElement('span');
          qtyBadge.style.cssText = 'position:absolute;top:-8px;right:-8px;background:#374151;color:#fff;font-size:11px;font-weight:700;border-radius:50%;width:22px;height:22px;display:flex;align-items:center;justify-content:center';
          qtyBadge.textContent = '1';
          thumbWrap.appendChild(thumb); thumbWrap.appendChild(qtyBadge);
          prodRow.appendChild(thumbWrap);
        }
        var prodMeta = document.createElement('div');
        prodMeta.style.cssText = 'flex:1;min-width:0';
        var prodName = document.createElement('div');
        prodName.style.cssText = 'font-size:15px;font-weight:700;color:#111827;overflow:hidden;text-overflow:ellipsis;white-space:nowrap';
        prodName.textContent = productTitle;
        var prodPriceEl = document.createElement('div');
        prodPriceEl.style.cssText = 'font-size:17px;font-weight:800;color:#111827;margin-top:4px';
        prodPriceEl.textContent = 'S/. ' + (productPrice || '0.00');
        prodMeta.appendChild(prodName); prodMeta.appendChild(prodPriceEl);
        prodRow.appendChild(prodMeta);
        productSummary.appendChild(prodRow);
      }

      // Tabla subtotal/envío/total — en un cuadro/card con celdas actualizables
      // Este bloque corre en runCOD, ANTES de que exista el formulario (y
      // por lo tanto antes de que se detecte la cantidad nativa, que solo
      // se lee al abrir el modal) -- acá todavía no hay "initialQty", solo
      // qtyVal (el stepper del sticky bar, que arranca en 1).
      var initSubtotal = (parseFloat(productPrice) || 0) * qtyVal;
      var initShipCost = (cfg.shipping && cfg.shipping.length > 0) ? (Number(cfg.shipping[0].price) || 0) : 0;
      var initTotal = initSubtotal + initShipCost;

      var summaryTable = document.createElement('div');
      summaryTable.style.cssText = 'background:#f8fafc;border:1px solid #e5e7eb;border-radius:10px;padding:10px 14px;margin-top:6px';

      var summaryRows = [
        { label: 'Subtotal', value: 'S/. ' + initSubtotal.toFixed(2), isTotal: false, id: 'cod-sum-subtotal' },
        { label: 'Envío',    value: initShipCost === 0 ? 'Gratis' : 'S/. ' + initShipCost.toFixed(2), isTotal: false, id: 'cod-sum-ship' },
        { label: 'Total',    value: 'S/. ' + initTotal.toFixed(2), isTotal: true,  id: 'cod-sum-total' },
      ];

      summaryRows.forEach(function(row) {
        var tr = document.createElement('div');
        tr.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:4px 0;' + (row.isTotal ? 'border-top:1px solid #d1d5db;margin-top:6px;padding-top:8px' : '');
        var tl = document.createElement('span');
        tl.style.cssText = 'font-size:13px;color:' + (row.isTotal ? '#111827' : '#6b7280') + ';font-weight:' + (row.isTotal ? '700' : '400');
        tl.textContent = row.label;
        var tv = document.createElement('span');
        tv.style.cssText = 'font-size:' + (row.isTotal ? '15px' : '13px') + ';font-weight:' + (row.isTotal ? '800' : '500') + ';color:' + (row.value === 'Gratis' ? '#16a34a' : '#111827');
        tv.textContent = row.value;
        if (row.id) tv.id = row.id;
        tr.appendChild(tl); tr.appendChild(tv);
        summaryTable.appendChild(tr);
      });
      productSummary.appendChild(summaryTable);
      drawer.appendChild(productSummary);

      // Container del formulario dentro del modal
      var formContainer = document.createElement('div');
      formContainer.style.cssText = 'padding:12px 16px 24px';
      drawer.appendChild(formContainer);

      overlay.appendChild(drawer);
      document.body.appendChild(overlay);

      // ── Construir formulario dentro del modal (lazy — solo al abrir) ──
      var formBuilt = false;
      var formOpenFired = false;
      var codScrollY = 0;
      function openModal() {
        overlay.classList.add('cod-open');
        // overflow:hidden solo no alcanza en iOS Safari (el fondo igual se
        // puede arrastrar) — fijar el body en su lugar sí lo bloquea de verdad.
        codScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + codScrollY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';

        // Si el cliente ya había cambiado la cantidad en el selector nativo
        // del tema ("Elegir cantidad") ANTES de abrir el formulario, eso se
        // ignoraba por completo -- el stepper propio del widget siempre
        // arrancaba en 1, sin mirar el selector nativo. Se lee acá, justo al
        // abrir (antes de construir el form, para que nazca ya con el
        // número correcto), y se usa como el valor real.
        // Ojo: muchas tiendas tienen VARIOS input[name="quantity"] en la
        // misma página (forms ocultos de apps de upsell/"comprados juntos",
        // barra sticky del tema, etc.), todos con el mismo name -- si se
        // toma el primero que aparece en el HTML se puede agarrar uno oculto
        // que nunca se tocó (confirmado en vivo: una tienda tenía 7). Por
        // eso acá se exige además que el campo esté realmente visible
        // (offsetParent !== null -- null cuando el elemento o algún
        // ancestro tiene display:none), que es el que el cliente realmente ve y toca.
        var nativeQtySels = ['form[action*="/cart/add"] input[name="quantity"]', '.product-form input[name="quantity"]', 'input[name="quantity"]'];
        var nativeQtyFound = false;
        for (var nqi = 0; nqi < nativeQtySels.length && !nativeQtyFound; nqi++) {
          var nqEls = document.querySelectorAll(nativeQtySels[nqi]);
          for (var nqj = 0; nqj < nqEls.length; nqj++) {
            if (formContainer.contains(nqEls[nqj])) continue; // el input propio del widget, no el del tema
            if (nqEls[nqj].offsetParent === null) continue; // oculto (display:none en él o en un ancestro)
            var nqVal = parseInt(nqEls[nqj].value, 10);
            if (nqVal > 0) { qtyVal = nqVal; nativeQtyFound = true; break; }
          }
        }
        qtyDisplay.textContent = String(qtyVal);

        if (!formBuilt) {
          formBuilt = true;
          ensureUbigeo().then(function (ubigeo) {
            buildForm(formContainer, cfg, shop, variantId, productPrice, ubigeo, qtyVal);
          });
          // InitiateCheckout (CAPI + Meta pixel) -- se dispara acá mismo,
          // al abrir el modal, ANTES de que buildForm() cree los campos
          // (por eso {} vacío es correcto en este punto exacto: no existe
          // "fields" todavía, no hay nada real que mandar sin inventarlo).
          var eid = uuid();
          fireMeta('InitiateCheckout', eid);
          fireServer(shop, 'InitiateCheckout', eid, {});
        } else {
          // El form ya existía de una apertura anterior -- si la cantidad
          // nativa cambió desde entonces, sincronizar el campo (si existe)
          // y disparar "input" (no "change") porque el listener que
          // recalcula el total y el badge escucha ese evento específico.
          var qtyField = formContainer.querySelector('input[name="quantity"]');
          if (qtyField) { qtyField.value = qtyVal; qtyField.dispatchEvent(new Event('input', { bubbles: true })); }
        }
        // FormOpen: contar apertura del formulario (solo 1 vez por sesión)
        if (!formOpenFired) {
          formOpenFired = true;
          var t = track();
          fetch(BACKEND_URL + '/api/public/track?shop=' + encodeURIComponent(shop), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              event: 'FormOpen', event_id: uuid(),
              tracking: { utm_source: t.utm_source, utm_medium: t.utm_medium, utm_campaign: t.utm_campaign },
            }),
          }).catch(function() {});
        }
      }

      function closeModal() {
        overlay.classList.remove('cod-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        window.scrollTo(0, codScrollY);
      }

      // Eventos de abrir/cerrar — a propósito, SOLO la X cierra el modal
      // (ni tocar afuera ni el handle lo cierran, para evitar perder datos
      // por un toque accidental).
      stickyBtn.addEventListener('click', openModal);
      closeBtn.addEventListener('click', closeModal);

      // ── Botón inline en la página del producto (EasySell style) ─────────
      var inlineWrap = document.createElement('div');
      inlineWrap.id = 'cod-inline-wrap';
      inlineWrap.style.cssText = 'margin:10px 0;width:100%';

      var inlineBtn = document.createElement('button');
      inlineBtn.id = 'cod-inline-btn';
      inlineBtn.type = 'button';
      inlineBtn.className = 'cod-btn-pulse';
      inlineBtn.style.cssText = 'width:100%;padding:14px 20px;background:' + pc + ';color:#fff;border:none;border-radius:' + r + ';font-size:16px;font-weight:700;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:3px;font-family:inherit;box-shadow:0 4px 14px rgba(0,0,0,0.18);transition:filter 0.15s';
      inlineBtn.onmouseenter = function(){ inlineBtn.style.filter='brightness(1.08)'; };
      inlineBtn.onmouseleave = function(){ inlineBtn.style.filter='none'; };
      var ibMain = document.createElement('span'); ibMain.textContent = btnTxt.trim();
      inlineBtn.appendChild(ibMain);
      if (btnSub) {
        var ibSub = document.createElement('span');
        ibSub.style.cssText = 'font-size:12px;font-weight:400;opacity:0.9';
        ibSub.textContent = btnSub;
        inlineBtn.appendChild(ibSub);
      }
      inlineBtn.onclick = openModal;
      inlineWrap.appendChild(inlineBtn);

      // Insertar inline button: buscar por selectores estándar → texto → formulario
      (function () {
        var insertSels = ['.shopify-payment-button','[name="add"]','.product-form__submit','.btn--add-to-cart','[data-shopify="payment-button"]','.product__submit-button','button[data-add-to-cart]'];
        var inserted = false;
        for (var isi = 0; isi < insertSels.length; isi++) {
          var anchor = document.querySelector(insertSels[isi]);
          if (anchor && !anchor.closest('#cod-sticky-bar') && !anchor.closest('#cod-inline-wrap')) {
            var anchorParent = anchor.closest('.product-form') || anchor.parentNode;
            anchorParent.appendChild(inlineWrap);
            inserted = true; break;
          }
        }
        if (!inserted) {
          // Buscar botón por texto contenido
          var allBtns = document.querySelectorAll('button, a.button, a.btn');
          for (var bi = 0; bi < allBtns.length; bi++) {
            var btxt = (allBtns[bi].textContent || '').toLowerCase();
            if ((btxt.includes('contra entrega') || btxt.includes('pago contra')) && !allBtns[bi].closest('#cod-sticky-bar')) {
              allBtns[bi].parentNode.insertBefore(inlineWrap, allBtns[bi].nextSibling);
              inserted = true; break;
            }
          }
        }
        if (!inserted) {
          // Último recurso: al final del product-form o product info
          var pf = document.querySelector('.product-form, [data-product-form], .product__info-container, .product-single__info, .product__info-wrapper');
          if (pf) pf.appendChild(inlineWrap);
        }
      })();

      // Smart sticky: aparece cuando el btn inline sale de pantalla, desaparece al volver
      // (no corre nada de esto si el merchant ocultó la barra -- ya ni está en el body)
      if (!cfg.hide_sticky_bar) (function () {
        function showSticky() { stickyBar.style.display = "flex"; }
        function hideSticky() { stickyBar.style.display = "none"; }
        var inlineEl = document.getElementById('cod-inline-btn');
        if (inlineEl && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries[0].isIntersecting ? hideSticky() : showSticky();
          }, { threshold: 0.2, rootMargin: "0px 0px -10px 0px" }).observe(inlineEl);
        } else {
          var stTick = false;
          window.addEventListener('scroll', function () {
            if (!stTick) {
              requestAnimationFrame(function () {
                window.scrollY > 350 ? showSticky() : hideSticky();
                stTick = false;
              });
              stTick = true;
            }
          }, { passive: true });
          if (window.scrollY > 350) showSticky();
        }
      })();

      // El modal solo se cierra con la X (a propósito: sin cerrar por swipe
      // ni por tocar afuera, para que el cliente no pierda lo que escribió
      // por un gesto accidental mientras hace scroll dentro del formulario).

      // Ocultar botones nativos de Shopify si la config lo indica
      (function () {
        var selectors = [
          '.shopify-payment-button',    // Buy Now (no configurable todavía, se sigue ocultando siempre)
          '[data-shopify="payment-button"]',
        ];
        // "Agregar al carrito" -- este sí es configurable (checkbox en
        // Configuración > Visibilidad). Por defecto true (mismo
        // comportamiento de siempre); si el merchant lo desmarca, hay que
        // deshacer el estilo que ya lo escondió apenas cargó la página,
        // porque ese estilo usa !important y una simple línea acá no alcanza.
        if (cfg.hide_native_add_to_cart === false) {
          var earlyHideStyle3 = document.getElementById('cod-hide-native-early');
          if (earlyHideStyle3) earlyHideStyle3.remove();
          // El de Buy Now/Pay hay que seguir ocultándolo igual -- reinyectar
          // solo esos dos selectores.
          var s3 = document.createElement('style');
          s3.id = 'cod-hide-native-buynow';
          s3.textContent = selectors.join(',') + '{display:none!important}';
          document.head.appendChild(s3);
        } else {
          selectors.push('[name="add"]', '.product-form__submit', '.btn--add-to-cart');
        }
        selectors.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.style.display = 'none';
          });
        });
      })();

    }).catch(function (e) { console.error('COD widget: no se pudo cargar la configuración —', e); });
}

/* ── Widget de CARRITO (Colocación = "Solo página del carrito" / "Toda la
   tienda") ────────────────────────────────────────────────────────────
   A diferencia de runCOD() -- que solo tiene sentido en una página de
   producto, porque necesita saber qué vender -- este corre en cualquier
   página: el carrito puede tener varios productos a la vez, y el cliente
   puede querer pagar contra entrega desde cualquier lado, no solo desde
   una página /cart (esta tienda usa un carrito tipo "drawer", así que
   muchos clientes nunca llegan a visitar esa URL). */
function runCartWidget(shop) {
  getConfig(shop).then(function (cfg) {
    if (cfg.form_enabled === false) return;
    if (cfg.placement !== 'cart_page' && cfg.placement !== 'all') return;
    // Ojo: NO se condiciona a que el carrito ya tenga productos acá. El
    // carrito puede estar vacío en el momento exacto en que carga la
    // página (recién entrando, antes del primer "agregar") -- si solo se
    // arma el observador cuando YA hay algo, el primer producto que el
    // cliente agrega nunca dispara nada (se descubrió así: con 1 producto
    // no aparecía el botón, con 2 sí, porque el 2do ya era una carga de
    // página nueva con el carrito ya no vacío). El observador de abajo no
    // necesita saber si hay productos -- solo espera a que el botón nativo
    // de pagar exista, sea cual sea el momento.
    buildCartWidget(shop, cfg);
  }).catch(function (e) { console.error('COD cart widget: no se pudo armar —', e); });
}

function buildCartWidget(shop, cfg, cart) {
  if (document.getElementById('cod-cart-styles')) return; // evita duplicar si el script corre 2 veces
  var pc  = cfg.primary_color || '#1a8917';
  var r   = (cfg.border_radius || 8) + 'px';
  var cur = cfg.currency_symbol || 'S/.';
  var tc  = cfg.text_color || '#000000';
  var fbc = cfg.field_border_color || cfg.border_color || '#d1d5db';
  var fBg = cfg.field_bg_color || '#ffffff';

  (function () {
    if (document.getElementById('cod-cart-styles')) return;
    var s = document.createElement('style');
    s.id = 'cod-cart-styles';
    s.textContent = [
      '#cod-cart-overlay{position:fixed;inset:0;z-index:9999;background:rgba(17,24,39,0.55);display:flex;align-items:flex-end;justify-content:center;opacity:0;pointer-events:none;transition:opacity 0.22s ease}',
      '#cod-cart-overlay.cod-open{opacity:1;pointer-events:auto}',
      '#cod-cart-drawer{background:#fff;border-radius:16px 16px 0 0;max-width:480px;width:100%;max-height:88vh;overflow-y:auto;transform:translateY(16px);transition:transform 0.22s ease;font-family:inherit;color:' + tc + '}',
      '#cod-cart-overlay.cod-open #cod-cart-drawer{transform:translateY(0)}',
      '.cod-cart-item{display:flex;align-items:center;gap:10px;padding:10px 0;border-bottom:1px solid #f3f4f6}',
      '.cod-cart-item img{width:52px;height:52px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;flex-shrink:0}',
      '.cod-cf{margin-bottom:10px}',
      '.cod-cf label{display:block;font-size:12px;font-weight:600;margin-bottom:4px}',
      '.cod-cf label em{color:#ef4444;font-style:normal;margin-left:2px}',
      '.cod-cf input,.cod-cf select{width:100%;padding:12px 10px;border:1px solid ' + fbc + ';background:' + fBg + ';border-radius:' + r + ';font-size:16px;box-sizing:border-box;font-family:inherit;color:' + tc + '}',
      '.cod-cf-err{font-size:11px;color:#ef4444;margin-top:3px;display:none}',
      '.cod-cart-ship-row{display:flex;align-items:center;gap:10px;padding:11px 12px;border:1.5px solid #e5e7eb;border-radius:' + r + ';cursor:pointer;margin-bottom:8px}',
    ].join('');
    document.head.appendChild(s);
  })();

  // Sin barra flotante global -- el botón vive solo DENTRO del panel del
  // carrito (más abajo), no en cada página. Antes había además una barra
  // fija en toda la pantalla, pero confundía al aparecer incluso en
  // páginas de producto sin que el cliente hubiera abierto el carrito.
  var overlay, drawer, built = false;

  function openOrRefreshCartModal() {
    if (!built) { built = true; fetch('/cart.js').then(function(r){return r.json();}).then(function(fresh){ cart = fresh; openCartModal(); }).catch(function(){ openCartModal(); }); }
    else { fetch('/cart.js').then(function(r){return r.json();}).then(function(fresh){ cart = fresh; renderCartModalContent(); overlay.classList.add('cod-open'); }).catch(function(){ overlay.classList.add('cod-open'); }); }
  }

  // Botón DENTRO del panel/drawer del carrito del tema, junto al botón
  // nativo de pagar -- ese panel se re-arma solo cada vez que cambia el
  // carrito (agregar/quitar/cambiar cantidad), así que un MutationObserver
  // es la única forma confiable de que el botón siga ahí después de cada
  // cambio (insertarlo una sola vez no alcanza, desaparece en el próximo
  // render del drawer).
  (function () {
    var checkoutSels = ['#CartDrawer-Checkout', '.cart__checkout-button', 'button[name="checkout"]', 'input[name="checkout"]'];
    function tryInsertDrawerBtn() {
      var checkoutEl = null;
      for (var i = 0; i < checkoutSels.length; i++) {
        checkoutEl = document.querySelector(checkoutSels[i]);
        if (checkoutEl) break;
      }
      if (!checkoutEl || !checkoutEl.parentNode) return;
      if (checkoutEl.parentNode.querySelector('#cod-drawer-btn')) return; // ya insertado en este render
      var drawerBtn = document.createElement('button');
      drawerBtn.id = 'cod-drawer-btn';
      drawerBtn.type = 'button';
      drawerBtn.style.cssText = 'width:100%;padding:13px 0;margin-top:8px;background:' + pc + ';color:#fff;font-weight:700;font-size:15px;border:none;border-radius:' + r + ';cursor:pointer;font-family:inherit';
      drawerBtn.textContent = (cfg.button_text || 'PAGO CONTRA ENTREGA').replace(/{total}/g, '').trim();
      drawerBtn.onclick = function (e) { e.preventDefault(); openOrRefreshCartModal(); };
      checkoutEl.parentNode.insertBefore(drawerBtn, checkoutEl.nextSibling);
    }
    tryInsertDrawerBtn();
    if ('MutationObserver' in window) {
      new MutationObserver(tryInsertDrawerBtn).observe(document.body, { childList: true, subtree: true });
    }
    // Red de respaldo: en vivo se vio que la PRIMERA vez que se agrega un
    // producto (carrito pasando de 0 a 1) el observer de arriba no
    // reacciona -- de la 2da vez en adelante sí. No se pudo confirmar la
    // causa exacta (probablemente el tema arma el drawer de una forma que
    // no dispara el observer esa primera vez), así que en vez de perseguir
    // el motivo exacto, esto revisa cada 1.2s sin importar qué mutación
    // haya pasado -- si el botón nativo está y el nuestro no, lo mete. Es
    // una revisión barata (un par de querySelector), no hay drama en
    // dejarla corriendo.
    setInterval(tryInsertDrawerBtn, 1200);
  })();

  function openCartModal() {
    overlay = document.createElement('div');
    overlay.id = 'cod-cart-overlay';
    drawer = document.createElement('div');
    drawer.id = 'cod-cart-drawer';
    overlay.appendChild(drawer);
    document.body.appendChild(overlay);
    renderCartModalContent();
    overlay.classList.add('cod-open');
  }

  function renderCartModalContent() {
    drawer.innerHTML = '';
    var header = el('div', { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: '0', background: '#fff' });
    header.appendChild(el('div', { fontSize: '15px', fontWeight: '700', color: tc }, { text: 'Favor ingresar tus datos para realizar el pedido' }));
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button'; closeBtn.innerHTML = '&times;'; closeBtn.setAttribute('aria-label', 'Cerrar');
    closeBtn.style.cssText = 'border:none;background:#f3f4f6;width:32px;height:32px;min-width:32px;border-radius:50%;font-size:20px;cursor:pointer;color:#374151;line-height:1;flex-shrink:0';
    closeBtn.onclick = function () { overlay.classList.remove('cod-open'); };
    header.appendChild(closeBtn);
    drawer.appendChild(header);

    var body = el('div', { padding: '12px 16px 20px' });
    drawer.appendChild(body);

    // Productos del carrito
    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'cod-cart-item';
      if (item.image) { var img = document.createElement('img'); img.src = item.image; row.appendChild(img); }
      var meta = el('div', { flex: '1', minWidth: '0' });
      var titleText = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '');
      meta.appendChild(el('div', { fontSize: '13px', fontWeight: '700', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: tc }, { text: titleText }));
      meta.appendChild(el('div', { fontSize: '12px', color: '#6b7280' }, { text: 'x' + item.quantity + ' · ' + cur + ' ' + (item.final_line_price / 100).toFixed(2) }));
      row.appendChild(meta);
      body.appendChild(row);
    });

    // Envío (mismas tarifas configuradas para el producto)
    var selectedShipping = (cfg.shipping && cfg.shipping.length > 0) ? cfg.shipping[0] : null;
    var subtotal = cart.total_price / 100;
    var totEl;
    if (cfg.shipping && cfg.shipping.length > 0) {
      var shipWrap = el('div', { marginTop: '12px' });
      shipWrap.appendChild(el('p', { margin: '0 0 8px', fontSize: '13px', fontWeight: '700', color: tc }, { text: 'Opciones de envío' }));
      cfg.shipping.forEach(function (rate, i) {
        var row = document.createElement('label');
        row.className = 'cod-cart-ship-row';
        row.style.borderColor = i === 0 ? pc : '#e5e7eb';
        var rb = document.createElement('input');
        rb.type = 'radio'; rb.name = 'cod_cart_shipping';
        rb.style.cssText = 'width:18px;height:18px;flex-shrink:0;accent-color:' + pc;
        if (i === 0) rb.checked = true;
        rb.addEventListener('change', function () {
          selectedShipping = rate;
          Array.prototype.forEach.call(shipWrap.querySelectorAll('.cod-cart-ship-row'), function (r2, idx) { r2.style.borderColor = idx === i ? pc : '#e5e7eb'; });
          recomputeTotal();
        });
        var label = el('div', { flex: '1', fontSize: '13px', fontWeight: '600', color: tc }, { text: (rate.emoji || '') + ' ' + rate.name });
        var price = el('div', { fontSize: '13px', fontWeight: '700', color: (Number(rate.price) || 0) === 0 ? '#16a34a' : tc }, { text: (Number(rate.price) || 0) === 0 ? 'Gratis' : cur + ' ' + Number(rate.price).toFixed(2) });
        row.appendChild(rb); row.appendChild(label); row.appendChild(price);
        shipWrap.appendChild(row);
      });
      body.appendChild(shipWrap);
    }

    // Resumen
    var summaryBox = el('div', { background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '10px 14px', marginTop: '10px' });
    var subEl = el('div', { display: 'flex', justifyContent: 'space-between', padding: '4px 0' });
    subEl.appendChild(el('span', { color: '#6b7280', fontSize: '13px' }, { text: 'Subtotal' }));
    subEl.appendChild(el('span', { fontSize: '13px', fontWeight: '600', color: tc }, { text: cur + ' ' + subtotal.toFixed(2) }));
    var shipRowEl = el('div', { display: 'flex', justifyContent: 'space-between', padding: '4px 0' });
    var shipLbl = el('span', { color: '#6b7280', fontSize: '13px' }, { text: 'Envío' });
    var shipVal = el('span', { fontSize: '13px', fontWeight: '600' });
    shipRowEl.appendChild(shipLbl); shipRowEl.appendChild(shipVal);
    var totRowEl = el('div', { display: 'flex', justifyContent: 'space-between', padding: '8px 0 0', marginTop: '6px', borderTop: '1px solid #d1d5db' });
    totRowEl.appendChild(el('span', { fontWeight: '700', color: tc }, { text: 'Total' }));
    totEl = el('span', { fontWeight: '800', color: tc });
    totRowEl.appendChild(totEl);
    summaryBox.appendChild(subEl); summaryBox.appendChild(shipRowEl); summaryBox.appendChild(totRowEl);
    body.appendChild(summaryBox);

    function recomputeTotal() {
      var shipCost = selectedShipping ? (Number(selectedShipping.price) || 0) : 0;
      shipVal.textContent = shipCost === 0 ? 'Gratis' : cur + ' ' + shipCost.toFixed(2);
      shipVal.style.color = shipCost === 0 ? '#16a34a' : tc;
      var total = subtotal + shipCost;
      totEl.textContent = cur + ' ' + total.toFixed(2);
      // Mismo manejo de {total} que el resto del widget -- si codBtn todavía
      // no existe (primera pasada, se crea más abajo) esto se salta acá y
      // el texto inicial ya sale bien armado en su propia creación.
      if (typeof codBtn !== 'undefined' && codBtn) {
        var txt = cfg.button_text || 'PAGO CONTRA ENTREGA';
        codBtn.textContent = txt.indexOf('{total}') >= 0 ? txt.replace('{total}', cur + ' ' + total.toFixed(2)) : txt + ' — ' + cur + ' ' + total.toFixed(2);
      }
    }

    // Datos de contacto (mismos campos configurados para el producto,
    // salvo "Cantidad" -- acá la cantidad ya viene fijada por el carrito).
    // "Imagen" sí aplica acá (antes se saltaba) -- es contenido informativo
    // configurado por el merchant, no depende de que sea un solo producto.
    var fieldsWrap = el('div', { marginTop: '14px' });
    body.appendChild(fieldsWrap);
    var fields = {}, errEls = {};
    ensureUbigeo().then(function (ubigeo) {
      cfg.fields.forEach(function (f) {
        if (f.key === 'quantity') return;
        var fType = f.field_type || 'text';
        if (fType === 'whatsapp_btn' || fType === 'link_btn') return; // no aplica acá
        if (fType === 'image' && f.placeholder) {
          var imgWrap = el('div', { marginBottom: '10px', textAlign: f.image_align || 'center' });
          var img = el('img', null, { src: f.placeholder });
          img.style.cssText = 'width:' + (f.image_size || 100) + '%;border-radius:6px;max-width:100%';
          imgWrap.appendChild(img);
          fieldsWrap.appendChild(imgWrap);
          return;
        }
        if (fType === 'image') return;
        var block = document.createElement('div');
        block.className = 'cod-cf';
        var label = document.createElement('label');
        label.textContent = f.label;
        if (f.required) { var ast = document.createElement('em'); ast.textContent = '*'; label.appendChild(ast); }
        block.appendChild(label);

        var inputEl;
        if (f.key === 'city' && ubigeo && fType !== 'select') {
          inputEl = buildCityField(ubigeo, fbc, fBg);
        } else if (fType === 'select' && f.options) {
          inputEl = document.createElement('select');
          var defOpt = document.createElement('option'); defOpt.value = ''; defOpt.textContent = f.placeholder || 'Selecciona...'; inputEl.appendChild(defOpt);
          f.options.split('|').forEach(function (o) { var opt = document.createElement('option'); opt.value = o.trim(); opt.textContent = o.trim(); inputEl.appendChild(opt); });
        } else {
          inputEl = document.createElement('input');
          inputEl.type = fType === 'number' ? 'number' : (fType || 'text');
          inputEl.placeholder = f.placeholder || f.label;
        }
        inputEl.name = f.key;
        block.appendChild(inputEl);
        var errEl = document.createElement('p');
        errEl.className = 'cod-cf-err';
        block.appendChild(errEl);
        fieldsWrap.appendChild(block);
        fields[f.key] = inputEl;
        errEls[f.key] = errEl;
      });

      // Guardar borrador -- esto nunca se agregó acá (solo existía en el
      // formulario de un solo producto), por eso ningún cliente que
      // abandonaba el carrito a medio llenar quedaba guardado. Usa el
      // primer producto del carrito como referencia (un borrador de
      // carrito puede tener varios, pero el campo de la base de datos es
      // uno solo).
      var draftVariantId = (cart.items && cart.items[0] && cart.items[0].variant_id) ? String(cart.items[0].variant_id) : '';
      function triggerCartSaveDraft() {
        var currentFields = {};
        for (var k in fields) { if (fields[k] && fields[k].value) currentFields[k] = fields[k].value; }
        saveDraft(shop, currentFields, draftVariantId);
      }
      for (var cfKey in fields) {
        if (fields[cfKey]) fields[cfKey].addEventListener('input', triggerCartSaveDraft);
      }
    });

    // Botón + envío
    var codBtn = document.createElement('button');
    codBtn.type = 'button';
    codBtn.style.cssText = 'width:100%;padding:13px 0;margin-top:14px;background:' + pc + ';color:#fff;font-weight:700;font-size:16px;border:none;border-radius:' + r + ';cursor:pointer';
    recomputeTotal(); // arma el texto del botón (con el total real) ahora que codBtn ya existe
    var msg = el('p', { margin: '8px 0 0', fontSize: '13px', textAlign: 'center' });
    body.appendChild(codBtn); body.appendChild(msg);

    // Paga con tarjeta -- mismo botón que en el formulario de un producto.
    if (cfg.card_enabled) {
      var cardBtn = document.createElement('button');
      cardBtn.type = 'button';
      cardBtn.style.cssText = 'width:100%;padding:12px 0;margin-top:8px;background:' + (cfg.card_color || '#141ac3') + ';color:' + (cfg.card_text_color || '#fff') + ';font-weight:700;font-size:14px;border:none;border-radius:' + r + ';cursor:pointer';
      cardBtn.textContent = cfg.card_text || 'Paga con tarjeta';
      cardBtn.onclick = function () {
        if (cfg.card_link) { window.location.href = cfg.card_link; return; }
        window.location.href = window.location.origin + '/cart';
      };
      body.appendChild(cardBtn);
    }

    var initFired = false;
    drawer.addEventListener('focusin', function () {
      if (initFired) return; initFired = true;
      var eid = uuid();
      fireMeta('InitiateCheckout', eid);
      // Manda lo que ya este escrito en ese momento -- normalmente vacio,
      // porque esto dispara en el primer foco (recien empieza a tocar el
      // formulario), pero si algun campo ya tiene valor (autocompletado del
      // navegador, o reabrio el modal) no hay razon para descartarlo.
      fireServer(shop, 'InitiateCheckout', eid, {
        name:  fields.name  && fields.name.value,
        phone: fields.phone && fields.phone.value,
        email: fields.email && fields.email.value,
        city:  fields.city  && fields.city.value,
      });
    });

    codBtn.onclick = function () {
      var hasError = false, firstInvalid = null;
      cfg.fields.forEach(function (f) {
        if (!fields[f.key]) return;
        var val = (fields[f.key].value || '').trim();
        if (!f.required && !val) return;
        var patternBad = val && f.regex_pattern && !testRegex(f.regex_pattern, val);
        if (!val || patternBad) {
          fields[f.key].style.borderColor = '#ef4444';
          if (errEls[f.key]) { errEls[f.key].textContent = f.error_message || (patternBad ? 'Formato inválido.' : 'Este campo es obligatorio.'); errEls[f.key].style.display = 'block'; }
          if (!firstInvalid) firstInvalid = fields[f.key];
          hasError = true;
        } else {
          fields[f.key].style.borderColor = fbc;
          if (errEls[f.key]) errEls[f.key].style.display = 'none';
        }
      });
      if (firstInvalid) firstInvalid.focus();
      if (hasError) { msg.style.color = '#ef4444'; msg.textContent = 'Por favor completa todos los campos requeridos.'; return; }

      codBtn.disabled = true;
      msg.style.color = '#6b7280';
      msg.textContent = 'Procesando tu pedido...';

      // Se relee /cart.js justo antes de enviar -- entre que se abrió el
      // modal y este click pueden pasar minutos, y el carrito real es la
      // única fuente de verdad de qué se está cobrando.
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (freshCart) {
        if (!freshCart.item_count) {
          codBtn.disabled = false;
          msg.style.color = '#ef4444';
          msg.textContent = 'Tu carrito quedó vacío. Cierra esta ventana y agrega productos de nuevo.';
          return;
        }
        var shipCost = selectedShipping ? (Number(selectedShipping.price) || 0) : 0;
        var payload = {
          name:    (fields.name    ? fields.name.value    : '').trim(),
          phone:   (fields.phone   ? fields.phone.value   : '').trim(),
          email:   (fields.email   ? fields.email.value   : '').trim(),
          city:    (fields.city    ? fields.city.value    : '').trim(),
          address: (fields.address ? fields.address.value : '').trim(),
          // line_total: lo que Shopify ya calculó para esa línea (con
          // cualquier descuento de paquete/cantidad ya aplicado) -- el
          // servidor lo valida contra el precio de catálogo antes de
          // usarlo, no se manda como si fuera la verdad absoluta.
          items: freshCart.items.map(function (it) { return { variant_id: it.variant_id, quantity: it.quantity, line_total: it.final_line_price / 100 }; }),
          shipping_cost: shipCost,
          shipping_name: selectedShipping ? selectedShipping.name : '',
          product_price: freshCart.total_price / 100,
          tracking: track(),
        };
        var ctrl = new AbortController();
        var timer = setTimeout(function () { ctrl.abort(); }, 30000);
        fetch(BACKEND_URL + '/api/public/order?shop=' + encodeURIComponent(shop), {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload), signal: ctrl.signal,
        })
          .then(function (resp) { clearTimeout(timer); return resp.json(); })
          .then(function (data) {
            if (data.ok) {
              // Faltaba acá -- sin esto, el borrador (y su Draft Order en
              // Shopify) nunca se marcaba como convertido, así que después
              // de un pedido exitoso quedaba un "Borrador abierto" Y un
              // pedido real al mismo tiempo, duplicado, en el panel de
              // Shopify.
              convertDraft(shop, data.order_id);
              var mode = cfg.redirect_mode || 'custom_page';
              if (mode === 'none') {
                msg.style.color = '#16a34a';
                msg.textContent = '✅ ¡Gracias por tu pedido! Te contactaremos para coordinar la entrega.';
              } else {
                msg.style.color = '#16a34a';
                msg.textContent = '✅ Pedido recibido. Redirigiendo...';
                var dest = cfg.thank_you_url || '/';
                if (mode === 'shopify' && data.order_status_url) dest = data.order_status_url;
                else if (mode === 'whatsapp' && cfg.redirect_whatsapp) {
                  dest = 'https://wa.me/' + cfg.redirect_whatsapp.replace(/\D/g, '') + '?text=' + encodeURIComponent('¡Hola! Acabo de realizar un pedido.');
                }
                setTimeout(function () { window.location.href = dest; }, 800);
              }
            } else {
              msg.style.color = '#ef4444';
              msg.textContent = data.detail || 'No se pudo procesar. Intenta de nuevo.';
              codBtn.disabled = false;
            }
          })
          .catch(function (err) {
            clearTimeout(timer);
            msg.style.color = '#ef4444';
            msg.textContent = (err && err.name === 'AbortError') ? '⚠️ Tiempo de espera agotado. Verifica tu conexión e intenta de nuevo.' : '⚠️ Error de conexión. Verifica tu internet e intenta de nuevo.';
            codBtn.disabled = false;
          });
      }).catch(function () {
        codBtn.disabled = false;
        msg.style.color = '#ef4444';
        msg.textContent = '⚠️ No se pudo leer tu carrito. Intenta de nuevo.';
      });
    };
  }
}
})();
